(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-quantity-picker"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  /**
   * Haptic Feedback Utility
   * - Respects device silent mode (Android handles this automatically)
   * - iOS doesn't support Vibration API, so we skip it
   * - Uses light 12ms vibration for tactile feedback
   */
  var HapticFeedback = {
    _canVibrate: null,
    _isEnabled: true,

    init: function() {
      // Check vibration support once
      this._canVibrate = 'vibrate' in navigator;

      // Check for reduced motion preference
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this._isEnabled = false;
      }
    },

    light: function() {
      if (!this._isEnabled || !this._canVibrate) return;
      try {
        navigator.vibrate(12);
      } catch (e) {}
    },

    medium: function() {
      if (!this._isEnabled || !this._canVibrate) return;
      try {
        navigator.vibrate(18);
      } catch (e) {}
    }
  };

  HapticFeedback.init();

  function initBundlePickers(root) {
    if (!root || !root.querySelectorAll) return;

    var pickers = root.querySelectorAll('[data-bundle-picker]:not([data-bundle-picker-initialized])');
    if (!pickers.length) return;

    pickers.forEach(function (picker) {
      picker.setAttribute('data-bundle-picker-initialized', 'true');

      var radioInputs = Array.from(picker.querySelectorAll('input[type="radio"][data-bundle-qty]'));
      if (!radioInputs.length) return;

      // Find the matching product form for this section
      var sectionId = picker.getAttribute('data-section-id');
      var form = null;

      if (sectionId) {
        form = document.querySelector('product-form-component[data-section-id="' + sectionId + '"]');
      }
      if (!form) {
        form = document.querySelector('product-form-component');
      }
      if (!form) return;

      // The variant options (size/colour radios) live in a SEPARATE block, not inside
      // product-form-component — so scope option lookups to the product-details container.
      var details = picker.closest('.product-details') || document;

      // The step-through reveal IIFE was deleted here 07-31 (feel WO-16, item 5).
      // It watched three separate event sources to drop .is-gated and play a
      // slide-down entrance. There is nothing left to reveal: the rows are
      // present from first paint and the only state change is an opacity
      // handled in CSS by nether-pdp.liquid.

      // Quantity input inside quantity-selector-component
      var quantityInput = form.querySelector('quantity-selector-component input[name="quantity"]');
      if (!quantityInput) {
        // Un-mark so a later init (section load, morph) can retry — bailing
        // while marked left a picker whose radios never bind: "3-Pack" chosen,
        // one unit added.
        picker.removeAttribute('data-bundle-picker-initialized');
        return;
      }

      // --- Colour pack builder: revealed on a 2+ pack. A count per colour (stepper),
      //     capped at the pack size; +/- disable at the bounds; "X of N" tracks the total.
      //     Rows come from the product's REAL colour variants; on add-to-cart it posts one
      //     line item per colour at the chosen size (see the submit interceptor below). ---
      var colorsEl = picker.querySelector('[data-pack-colors]');
      var qtyWrap = colorsEl && colorsEl.querySelector('[data-pack-qty]');
      var countEl = colorsEl && colorsEl.querySelector('[data-pack-count]');
      var qtyRows = qtyWrap ? Array.prototype.slice.call(qtyWrap.querySelectorAll('.bundle-picker__qtyrow')) : [];
      var packQty = 1;

      // colour::size -> variant id, plus the set of sizes, parsed from the JSON blob.
      var variantMap = {};
      var sizeSet = {};
      if (colorsEl) {
        var mapEl = colorsEl.querySelector('[data-bundle-variantmap]');
        if (mapEl) {
          try {
            variantMap = JSON.parse(mapEl.textContent);
            Object.keys(variantMap).forEach(function (k) {
              var parts = k.split('::');
              if (parts[1]) sizeSet[parts[1]] = true;
            });
          } catch (e) { variantMap = {}; }
        }
      }

      function rowVal(row) { return parseInt(row.querySelector('[data-qty]').textContent, 10) || 0; }
      function packTotal() {
        return qtyRows.reduce(function (s, r) { return s + rowVal(r); }, 0);
      }
      // Boxer-brief silhouette (user 07-25: longer legs than the middle, not a
      // brief V): waistband, straight legs ~2/3 of the height, shallow notch.
      var BRIEF_SVG = '<svg viewBox="0 0 20 14" aria-hidden="true"><path d="M2 1h16v3l-1 9h-5l-1.4-6h-1.2L8 13H3L2 4Z"/></svg>';
      function syncRowSlots(row, n) {
        var track = row.querySelector('[data-row-slots]');
        if (!track) return;
        var have = track.children.length;
        while (have < n) {
          var pip = document.createElement('span');
          pip.className = 'bundle-picker__slot';
          pip.style.setProperty('--dot', row.getAttribute('data-hex') || '#888');
          pip.innerHTML = BRIEF_SVG;
          track.appendChild(pip);
          have++;
        }
        while (have > n) {
          track.removeChild(track.lastElementChild);
          have--;
        }
      }
      // Sticky-bar guard. We cannot stop Horizon's sticky handler from a click
      // listener — sticky-add-to-cart registers on document-capture BEFORE this
      // block's script, so it paints the checkmark + fly-to-cart before we ever
      // see the event. Instead we flag the incomplete state on <html> and let
      // nether-pdp's syncStickyGate strip the button's on:click (the same
      // technique the size gate uses). One owner for the attribute.
      function syncMixFlag() {
        if (!colorsEl) return;
        var incomplete = !colorsEl.hidden && packTotal() !== packQty;
        var root = document.documentElement;
        if (incomplete) root.setAttribute('data-nether-mix-incomplete', '');
        else root.removeAttribute('data-nether-mix-incomplete');
        document.dispatchEvent(new CustomEvent('nether:mix-state'));
      }

      function updatePackColors() {
        var total = packTotal();
        if (countEl) countEl.textContent = total + ' of ' + packQty;
        colorsEl.classList.toggle('is-complete', total === packQty && packQty > 0);
        syncMixFlag();
        qtyRows.forEach(function (r) {
          var n = rowVal(r);
          r.classList.toggle('is-active', n > 0);
          syncRowSlots(r, n);
          var down = r.querySelector('[data-step="down"]');
          var up = r.querySelector('[data-step="up"]');
          if (down) down.disabled = n <= 0;
          if (up) up.disabled = total >= packQty;
        });
      }
      function showPackColors(qty) {
        if (!colorsEl) return;
        packQty = qty;
        qtyRows.forEach(function (r) { r.querySelector('[data-qty]').textContent = '0'; });
        colorsEl.hidden = false;
        updatePackColors();
      }
      function hidePackColors() {
        if (colorsEl) colorsEl.hidden = true;
        syncMixFlag();
      }

      // The selected SIZE comes from the variant picker (the colour is driven by the builder).
      function selectedSize() {
        var checked = details.querySelectorAll('.variant-option input[type="radio"]:checked');
        for (var i = 0; i < checked.length; i++) {
          if (sizeSet[checked[i].value]) return checked[i].value;
        }
        return null;
      }
      // Drive the native colour variant so Horizon swaps the gallery in place (no reload).
      function driveColor(colorName) {
        var esc = (window.CSS && CSS.escape) ? CSS.escape(colorName) : colorName;
        var input = details.querySelector('.variant-option input[type="radio"][value="' + esc + '"]');
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          input.click();
        }
      }

      if (colorsEl) {
        qtyRows.forEach(function (row) {
          var valEl = row.querySelector('[data-qty]');
          var up = row.querySelector('[data-step="up"]');
          var down = row.querySelector('[data-step="down"]');
          var nameBtn = row.querySelector('[data-color-preview]');
          if (up) up.addEventListener('click', function () {
            if (packTotal() >= packQty) return;
            valEl.textContent = String(rowVal(row) + 1);
            HapticFeedback.light();
            updatePackColors();
          });
          if (down) down.addEventListener('click', function () {
            var n = rowVal(row);
            if (n <= 0) return;
            valEl.textContent = String(n - 1);
            HapticFeedback.light();
            updatePackColors();
          });
          // Tap the swatch/name to preview that colour in the gallery.
          if (nameBtn) nameBtn.addEventListener('click', function () {
            driveColor(row.getAttribute('data-color'));
          });
        });
        var preChecked = radioInputs.filter(function (r) { return r.checked; })[0];
        if (preChecked) {
          var pq = parseInt(preChecked.getAttribute('data-bundle-qty') || '1', 10);
          if (pq > 1) showPackColors(pq);
        }
      }

      // --- Cart wiring. When the builder is active, intercept the form submit (capture phase,
      //     so it beats Horizon's handler; also covers the sticky bar, which puppets this same
      //     button) and add one line item per colour at the selected size. An incomplete mix
      //     blocks + nudges; a complete mix posts items[] and refreshes/opens the drawer. ---
      function buildMixItems() {
        var size = selectedSize();
        if (!size) return { error: 'size' };
        var items = [];
        for (var i = 0; i < qtyRows.length; i++) {
          var n = rowVal(qtyRows[i]);
          if (n > 0) {
            var id = variantMap[qtyRows[i].getAttribute('data-color') + '::' + size];
            if (id) items.push({ id: Number(id), quantity: n });
          }
        }
        return { items: items };
      }
      function flashCount(msg) {
        if (!countEl) return;
        countEl.textContent = msg;
        countEl.classList.add('bundle-picker__colors-count--warn');
        setTimeout(function () {
          countEl.classList.remove('bundle-picker__colors-count--warn');
          updatePackColors();
        }, 1600);
      }
      function mixedAdd(items) {
        var routes = (window.Theme && Theme.routes) || {};
        var addUrl = routes.cart_add_url || '/cart/add.js';
        var cartUrl = routes.cart_url || '/cart';
        var sectionIds = [];
        document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) {
          sectionIds.push(c.dataset.sectionId);
        });
        var body = { items: items };
        if (sectionIds.length) body.sections = sectionIds.join(',');
        return fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(function (addResp) {
          if (addResp.status) throw new Error(addResp.description || addResp.message || 'add failed');
          // Fetch the whole cart for the header count, then fire the standard event so the
          // drawer opens + morphs and the cart icon updates (same contract Horizon uses).
          return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              // Re-render the cart sections through Horizon's own morph /
              // sectionRenderer path BEFORE announcing the update. Relying on
              // the event payload alone left the drawer showing "your bag is
              // empty" whenever the page had loaded with an empty cart.
              var refreshed = (window.NetherCart && window.NetherCart.refreshCartSections)
                ? window.NetherCart.refreshCartSections(addResp.sections)
                : Promise.resolve(false);
              return Promise.resolve(refreshed).then(function () { return cart; });
            })
            .then(function (cart) {
              var ev = new Event('shopify:cart:lines-update', { bubbles: true });
              ev.action = 'add';
              ev.context = 'product';
              ev.lines = items.map(function (it) { return { merchandiseId: String(it.id), quantity: it.quantity }; });
              ev.promise = Promise.resolve({
                cart: null,
                detail: {
                  itemCount: cart.item_count,
                  items: cart.items,
                  sections: addResp.sections,
                  source: 'nether-bundle',
                  didError: false
                }
              });
              document.dispatchEvent(ev);
            });
        });
      }
      if (form && colorsEl) {
        // Intercept the add-to-cart CLICK, not the submit. Horizon delegates on:submit on
        // document-capture and registers before us, so it always wins the submit race and
        // adds first. But the form submission is the click's DEFAULT ACTION — calling
        // preventDefault() on the click (from any listener) cancels the submit outright, so
        // Horizon's handleSubmit never runs. This also covers the sticky bar, which adds by
        // puppeting this same button's .click(). Scope to this picker's product form.
        document.addEventListener('click', function (e) {
          if (!e.target || !e.target.closest) return;
          var btn = e.target.closest('[ref="addToCartButton"]');
          var inForm = btn && form.contains(btn);
          // The sticky bar's own button lives OUTSIDE the product form and adds
          // by puppeting the real ATC. Catching only the in-form button meant a
          // blocked mix still let sticky-add-to-cart paint the checkmark +
          // fly-to-cart first (false success on desktop, where the quick-buy
          // sheet's 3-state handler is intentionally not in play).
          var stickyBtn = e.target.closest('.sticky-add-to-cart__button');
          if (!inForm && !stickyBtn) return;
          if (colorsEl.hidden) return;                  // 1-pair pack / builder off -> normal add
          var total = packTotal();
          if (stickyBtn && total === packQty) return;   // complete: let the normal path puppet through
          // stopImmediatePropagation is required, not just stopPropagation:
          // Horizon's on:click delegation lives on this same node (document,
          // capture). Without it, sticky-add-to-cart still played the checkmark
          // + fly-to-cart on a BLOCKED add — false success, nothing in the bag.
          if (total !== packQty) {                      // incomplete mix -> block + nudge
            e.preventDefault();
            e.stopImmediatePropagation();
            flashCount('Pick ' + packQty + ' total');
            if (stickyBtn) colorsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          var built = buildMixItems();
          if (built.error === 'size') {                 // builder engaged but no size -> block, don't
            e.preventDefault();                         // fall through to Horizon (which would add the
            e.stopImmediatePropagation();               // wrong single colour)
            flashCount('Select a size');
            return;
          }
          if (!built.items || !built.items.length) return; // nothing to add -> let Horizon handle
          e.preventDefault();                           // cancel the form submit (Horizon's add)
          e.stopImmediatePropagation();
          HapticFeedback.medium();
          mixedAdd(built.items).catch(function (err) {
            console.error('[bundle] mixed add failed', err);
            flashCount('That did not go through. Try again.');
          });
        }, true);
      }

      // THE BUTTON ALWAYS STATES WHAT IT WILL ADD (2026-08-01).
      //
      // This replaces the pack gate. Nothing is pre-selected and nothing is
      // blocked, so the button carries the answer instead: plain "Add to cart"
      // until a pack is chosen, then "Add to cart · 3 pairs". A customer can
      // never add a multi-pack they did not see stated.
      //
      // Both buttons, always: the buy-area one and the sticky bar's.
      //
      // Only the label's own <span> is written. Writing textContent on the
      // container would wipe the quantityDisplay / quantityNumber ref spans that
      // Horizon's sticky-add-to-cart component requires, which throws
      // MissingRefError and breaks the sticky bar.
      // The quantity the tiles are actually set to, and the single source of
      // truth for the button's suffix. Kept in a variable rather than read back
      // out of the DOM because the DOM is exactly what keeps getting replaced.
      var desiredQty = 1;

      function paintAtcQuantity(qty) {
        var n = parseInt(qty, 10);
        if (!n || n < 1) n = 1;
        desiredQty = n;
        applyAtcQuantity();
      }

      function applyAtcQuantity() {
        document.querySelectorAll('[ref="addToCartButton"] .add-to-cart-text__content').forEach(function (atcTextEl) {
          var labelSpan = atcTextEl.querySelector(':scope > span:not([ref])');
          if (!labelSpan) return;
          // While the size gate is up the button reads "Select a size" from a
          // ::after overlay and its own label is hidden. Leave it alone: the
          // quantity is painted the moment the gate lifts.
          if (labelSpan.textContent.indexOf('Select') !== -1) return;
          if (!labelSpan.dataset.baseText) {
            labelSpan.dataset.baseText = labelSpan.textContent.trim().split(' · ')[0];
          }
          var baseText =
            labelSpan.dataset.baseText ||
            (window.Theme && Theme.translations && Theme.translations.add_to_cart) ||
            'Add to cart';
          /* ONE PAIR SAYS NOTHING.

             The button used to open the page reading "Add to cart · 1 pair"
             with nothing selected, which announced a pack the buyer had not
             chosen and, since the 1 Pair tile was removed on 2026-08-01, one
             they could not see either. A single pair is the unstated default;
             the suffix is for a pack.

             "Add to cart · 3 pairs", not "Add to cart 3 Pairs". The old form ran
             the label straight onto the base text and was not a sentence. */
          var wanted = desiredQty > 1 ? baseText + ' · ' + desiredQty + ' pairs' : baseText;
          // Only ever write a CHANGE. This runs from a MutationObserver that
          // watches the same subtree, so an unconditional write would re-enter
          // itself forever.
          if (labelSpan.textContent !== wanted) labelSpan.textContent = wanted;
        });
      }

      /* REPAINT WHENEVER THE MORPH LANDS, NOT ON A GUESS.

         Choosing a pack and THEN a size lost the suffix: selecting a size
         re-renders the buy area, and the resync below is a 60ms timeout, so on
         a slower response the morph arrived after the repaint and replaced the
         painted label with the server's plain one. The button then read "Add to
         cart" while the form quantity was 5 — not a wrong cart, but the button
         disagreeing with itself, which is the kind of thing that makes a page
         feel unfinished.

         Timeouts cannot win that race; they can only be tuned until the machine
         changes. Watching the subtree and re-applying is timing-independent, and
         because applyAtcQuantity writes only on a difference it costs nothing
         when nothing moved. Coalesced so a large morph does not run it once per
         mutation.

         The coalesce is a TIMEOUT, not requestAnimationFrame. rAF does not fire
         in a tab that is not compositing — backgrounded, or a phone with the
         browser behind another app — and the queued flag would then latch on
         forever and kill every later repaint. That is not hypothetical: it is
         how this was found. rAF is for scheduling paint work; keeping the label
         honest is correctness work, and it has to run whether or not anyone is
         currently looking. */
      /* The host has to contain BOTH add-to-cart buttons. There are two — the
         one in the buy area and the one in the sticky bar — and the sticky bar
         renders in its own section, outside .product-details, so observing the
         buy area alone left the phone's primary CTA unwatched. <main> is their
         nearest shared ancestor. */
      var repaintQueued = false;
      var atcHost = document.querySelector('main') || document.body;
      new MutationObserver(function () {
        if (repaintQueued) return;
        repaintQueued = true;
        setTimeout(function () {
          repaintQueued = false;
          applyAtcQuantity();
        }, 0);
      }).observe(atcHost, { childList: true, subtree: true, characterData: true });

      // First paint, and again after any morph re-renders the buttons, so the
      // stated quantity is never missing and never stale.
      function syncAtcQuantity() {
        var checked = radioInputs.filter(function (r) { return r.checked; })[0];
        var qty = checked ? parseInt(checked.getAttribute('data-bundle-qty'), 10) : 1;
        paintAtcQuantity(qty);
      }
      syncAtcQuantity();
      ['variant:update', 'variant:selected', 'shopify:section:load'].forEach(function (ev) {
        document.addEventListener(ev, function () { setTimeout(syncAtcQuantity, 60); });
      });
      document.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('.product-details .variant-option--buttons input[type="radio"]')) {
          setTimeout(syncAtcQuantity, 60);
        }
      });

      radioInputs.forEach(function (input) {
        var label = input.closest('.bundle-picker__button');

        // Touch feedback on press
        if (label) {
          label.addEventListener('touchstart', function() {
            HapticFeedback.light();
          }, { passive: true });
        }

        /* TAP THE CHOSEN TILE AGAIN TO GO BACK TO ONE PAIR.
           The tiles start at 2 now (2026-08-01), because one pair is what the
           button already adds and a tile for it was just a tile for "no thanks".
           But a radio cannot be unchecked by clicking it, so without this there
           is no way back down: tap 2 by accident and the only route to a single
           pair is a page reload.

           It takes BOTH handlers, and the reason is the one place the obvious
           version goes wrong. This was written as a single mousedown listener
           calling preventDefault, on the reasoning that mousedown lands before
           the radio is checked. The first half is true and the second does not
           follow: a label activates its control on CLICK, so cancelling
           mousedown cancels focus, not activation. The click that followed
           re-checked the radio and fired change, which put the quantity
           straight back. Tapping the chosen tile did nothing at all.

           So the two events split the job. mousedown is the only moment the
           PRE-activation state is still readable — by click time the spec has
           already flipped .checked, so a click handler alone cannot tell a first
           tap from a second. It records what it saw. click then does the work
           and cancels the activation, which is the event where cancelling
           actually means something. touchstart records too: a tap can reach
           click without a mousedown, and without that the first tap on a phone
           would read as a de-select. */
        var wasCheckedOnPress = false;
        if (label) {
          label.addEventListener('mousedown', function () {
            wasCheckedOnPress = input.checked;
          });
          label.addEventListener('touchstart', function () {
            wasCheckedOnPress = input.checked;
          }, { passive: true });

          label.addEventListener('click', function (e) {
            if (!wasCheckedOnPress) return;
            wasCheckedOnPress = false;
            e.preventDefault();
            input.checked = false;
            quantityInput.value = 1;
            quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
            quantityInput.dataset.bundleLabel = '';
            hidePackColors();
            paintAtcQuantity(1);
            HapticFeedback.light();
          });
        }

        input.addEventListener('change', function () {
          if (!input.checked) return;

          var qty = parseInt(input.getAttribute('data-bundle-qty') || '1', 10);
          if (!qty || qty < 1) qty = 1;

          // Reveal the colour builder for multi-packs; a single pair needs no mix.
          if (qty > 1) { showPackColors(qty); } else { hidePackColors(); }

          // Haptic feedback on selection
          HapticFeedback.medium();

          quantityInput.value = qty;

          // Let the theme JS know quantity changed
          quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

          // Track bundle selection
          var labelEl = label ? label.querySelector('.bundle-picker__main') : null;
          var labelText = labelEl ? labelEl.textContent.trim() : '';

          // Store bundle label on quantity input so product-form.js can read it
          quantityInput.dataset.bundleLabel = (qty > 1 && labelText) ? labelText : '';

          paintAtcQuantity(qty);

          if (window.NetherAnalytics) {
            NetherAnalytics.track('select_bundle', {
              bundle_quantity: qty,
              bundle_label: labelText,
              page_path: window.location.pathname
            });
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBundlePickers(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initBundlePickers(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nether-bundle-builder"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Flags the theme editor for the one-button-on-screen rule in the sheet
       above. Set once, at parse time, so it is already on the element before
       the editor can select a block and swing [open]. */
    if (window.Shopify && window.Shopify.designMode) {
      document.documentElement.setAttribute('data-bb-editor', '');
    }

    function init(root) {
      (root || document).querySelectorAll('[data-nether-bb]:not([data-bb-init])').forEach(function (bb) {
        bb.setAttribute('data-bb-init', 'true');

        var rows = Array.prototype.slice.call(bb.querySelectorAll('[data-bb-row]'));
        var countEl = bb.querySelector('[data-bb-count]');
        var addBtn = bb.querySelector('[data-bb-add]');
        var msgEl = bb.querySelector('[data-bb-msg]');
        var mapEl = bb.querySelector('[data-bb-variantmap]');
        if (!rows.length || !addBtn || !mapEl) return;

        var variantMap = {};
        try { variantMap = JSON.parse(mapEl.textContent || '{}'); } catch (e) { variantMap = {}; }

        function rowVal(row) {
          return parseInt(row.querySelector('[data-bb-qty]').textContent, 10) || 0;
        }

        function total() {
          return rows.reduce(function (sum, r) { return sum + rowVal(r); }, 0);
        }

        /* The size lives in the variant picker, which is a separate block, so
           read it from the DOM rather than assuming. Excludes the colour
           fieldset, which Horizon also renders as buttons. */
        function selectedSize() {
          var input = document.querySelector(
            '.product-details .variant-option--buttons:not([data-option-id$="-color"]) input[type="radio"]:checked'
          );
          return input ? input.value : null;
        }

        function show(msg) {
          if (!msgEl) return;
          msgEl.textContent = msg;
          msgEl.hidden = !msg;
        }

        /* One chip per pair, filled in this row's colour. Always shows at least
           one empty ghost so there is a visible slot inviting the next pair, and
           never fewer slots than pairs already chosen.

           The chips used to be boxer-brief silhouettes. They were dropped
           2026-08-01: at 20x14 the garment was unreadable, and the row already
           says which product this is. What the customer actually needs to see is
           WHICH COLOUR they are stacking up, so the chip is now just the colour,
           and the shape stays out of the way. */
        var MIN_SLOTS = 5;

        function syncSlots(row, n) {
          var track = row.querySelector('[data-bb-slots]');
          if (!track) return;
          var want = Math.max(MIN_SLOTS, n + 1);

          while (track.children.length < want) {
            var pip = document.createElement('span');
            pip.className = 'nether-bb__pip';
            track.appendChild(pip);
          }
          while (track.children.length > want) {
            track.removeChild(track.lastChild);
          }

          Array.prototype.forEach.call(track.children, function (pip, i) {
            var filled = i < n;
            var was = pip.classList.contains('is-filled');
            pip.classList.toggle('is-filled', filled);
            // Pop only the pip that just filled, not every one on every render.
            pip.classList.remove('is-just-filled');
            if (filled && !was) {
              // Force a reflow so the class re-triggers if this pip popped before.
              void pip.offsetWidth;
              pip.classList.add('is-just-filled');
            }
          });
        }

        /* "Add 3-pack to cart" tells the customer what they built. Falls back to
           the block's own label while the pack is empty. */
        var addLabel = addBtn.textContent.trim();

        /* What the pack costs, on the button (owner 2026-08-03: "price should get
           added to the button... just in total dollar amounts").

           Reasoning for the tiers is on the data attributes in the markup above:
           they mirror Shopify's automatic discounts, and because both are
           cart-wide ">= quantity" rules the figure can only ever come out at or
           below what is actually charged. Never floor or round this: print the
           exact cents, or the theme quotes less than Shopify bills. */
        var unitPrice = parseInt(bb.getAttribute('data-bb-unit-price'), 10) || 0;
        var tier3 = parseFloat(bb.getAttribute('data-bb-tier-3')) || 0;
        var tier5 = parseFloat(bb.getAttribute('data-bb-tier-5')) || 0;

        /* Take the currency prefix off a price the page already rendered.
           shop.money_format is NOT the answer here: it reports a bare "$" while
           every .price on this store prints "C$43", because the storefront adds
           the country prefix at render time rather than in the format string.
           Reading what was actually painted matches the customer's view and
           follows the market automatically. The Liquid attribute is the
           fallback for the case where no price has rendered yet. */
        function detectPrefix() {
          var els = document.querySelectorAll('.price');
          for (var i = 0; i < els.length; i++) {
            // A leaf price node only, e.g. "C$43". Containers stack the sale
            // and regular price into one string and would mis-parse.
            var m = els[i].textContent.trim().match(/^([^\d]{0,4})[\d.,]+$/);
            if (m) return m[1];
          }
          return bb.getAttribute('data-bb-currency') || '$';
        }
        var currency = detectPrefix();

        function packTotal(n) {
          if (!unitPrice || !n) return null;
          var pct = n >= 5 ? tier5 : (n >= 3 ? tier3 : 0);
          var cents = Math.round(unitPrice * n * (100 - pct) / 100);
          var whole = Math.floor(cents / 100);
          var rem = cents % 100;
          // Whole dollars stay clean; cents are shown in full when they exist,
          // because a rounded total is the one thing this must never print.
          return currency + whole + (rem ? '.' + String(rem).padStart(2, '0') : '');
        }

        function sync() {
          var n = total();
          if (countEl) countEl.textContent = n === 1 ? '1 selected' : n + ' selected';
          addBtn.disabled = n === 0;
          var money = packTotal(n);
          var suffix = money ? ' · ' + money : '';
          addBtn.textContent = n > 1 ? 'Add ' + n + '-pack to cart' + suffix : (n === 1 ? 'Add 1 pair to cart' + suffix : addLabel);
          rows.forEach(function (r) {
            var v = rowVal(r);
            r.classList.toggle('is-active', v > 0);
            var minus = r.querySelector('[data-bb-step="down"]');
            if (minus) minus.disabled = v === 0;
            syncSlots(r, v);
          });
          if (n > 0) show('');
        }

        bb.addEventListener('click', function (e) {
          var step = e.target.closest && e.target.closest('[data-bb-step]');
          if (!step) return;
          var row = step.closest('[data-bb-row]');
          var qtyEl = row.querySelector('[data-bb-qty]');
          var v = parseInt(qtyEl.textContent, 10) || 0;
          v += step.getAttribute('data-bb-step') === 'up' ? 1 : -1;
          if (v < 0) v = 0;
          qtyEl.textContent = String(v);
          sync();
        });

        addBtn.addEventListener('click', function () {
          if (addBtn.disabled) return;

          var size = selectedSize();
          if (!size) {
            show('Choose your size above first.');
            return;
          }

          var items = [];
          var missing = false;
          rows.forEach(function (r) {
            var n = rowVal(r);
            if (!n) return;
            var id = variantMap[r.getAttribute('data-color') + '::' + size];
            if (!id) { missing = true; return; }
            items.push({ id: id, quantity: n });
          });

          if (missing) { show('That size is not available in one of those colours.'); return; }
          if (!items.length) return;

          addBtn.disabled = true;
          show('');

          var routes = (window.Theme && window.Theme.routes) || {};
          var addUrl = routes.cart_add_url || '/cart/add.js';
          var cartUrl = routes.cart_url || '/cart';
          var sectionIds = [];
          document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) {
            sectionIds.push(c.dataset.sectionId);
          });
          var body = { items: items };
          if (sectionIds.length) body.sections = sectionIds.join(',');

          fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          })
            .then(function (r) { return r.json(); })
            .then(function (addResp) {
              if (addResp.status) throw new Error(addResp.description || addResp.message || 'add failed');
              return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  // Re-render through Horizon's own morph path before announcing,
                  // or a drawer opened from an empty cart renders unstyled.
                  var refreshed = window.NetherCart && window.NetherCart.refreshCartSections
                    ? window.NetherCart.refreshCartSections(addResp.sections)
                    : Promise.resolve(false);
                  return Promise.resolve(refreshed).then(function () { return cart; });
                })
                .then(function (cart) {
                  var ev = new Event('shopify:cart:lines-update', { bubbles: true });
                  ev.action = 'add';
                  ev.context = 'product';
                  ev.lines = items.map(function (it) {
                    return { merchandiseId: String(it.id), quantity: it.quantity };
                  });
                  ev.promise = Promise.resolve({
                    cart: null,
                    detail: {
                      itemCount: cart.item_count,
                      items: cart.items,
                      sections: addResp.sections,
                      source: 'nether-bundle-builder',
                      didError: false
                    }
                  });
                  document.dispatchEvent(ev);

                  // Reset so a second bundle starts clean.
                  rows.forEach(function (r) { r.querySelector('[data-bb-qty]').textContent = '0'; });
                  bb.removeAttribute('open');
                  sync();
                });
            })
            .catch(function () {
              show('That did not go through. Try again.');
            })
            .then(function () { addBtn.disabled = total() === 0; });
        });

        /* Opening the builder is a commitment to the multi-pack path, so give it
           the screen: collapse the single-pack tiles it replaces and lift it to
           the top of the view. Everything comes back on close. */
        /* Focus mode. Opening the builder clears everything that offers a
           COMPETING way to buy — "Choose your pack" and the main Add to cart —
           so the only two moves left are build a multi-pack, or close the
           chevron and go back. The sticky bar is handled in CSS.

           Collapsed between two REAL pixel heights: max-block-size cannot
           transition from its default `none`, so measure first. */
        /* Resolved on every call, never cached. Choosing a size morphs the
           product section, which REPLACES .bundle-picker and .product-form-buttons
           with fresh nodes — a list captured at init still points at the detached
           originals, so the collapse silently did nothing once a size had been
           picked (measured: packs stayed at full height). */
        function focusTargets() {
          return [
            document.querySelector('.product-details .bundle-picker'),
            document.querySelector('.product-details .product-form-buttons'),
            // The shipping note sits between the add-to-cart and this builder, so
            // it would otherwise be left stranded in the gap they leave behind.
            document.querySelector('.product-details .nether-ship-note')
          ].filter(Boolean);
        }
        var focusTimer = 0;
        // Height transition is 0.45s (set in nether-pdp.liquid); the caps come
        // off just after it, and the close scroll waits for that.
        var CAP_RELEASE_MS = 600;

        /* Focus mode is a small-screen compromise only — see the media query in
           the stylesheet above. On desktop the builder and the pack tiles fit
           together, so nothing is collapsed and nothing is scrolled. */
        function isCompact() {
          return window.matchMedia('(max-width: 749px)').matches;
        }

        function setFocusMode(hidden) {
          clearTimeout(focusTimer);
          var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var targets = focusTargets();

          if (!isCompact()) {
            // Leave the buy area alone, and clear anything a previous
            // narrow-viewport session left capped.
            targets.forEach(function (el) { el.style.maxBlockSize = ''; });
            return;
          }

          targets.forEach(function (el) {
            if (reduced) {
              el.style.maxBlockSize = hidden ? '0px' : '';
              return;
            }
            var h = el.scrollHeight;
            if (hidden) {
              el.style.maxBlockSize = h + 'px';
              void el.offsetHeight; // commit the start value
              el.style.maxBlockSize = '0px';
            } else {
              el.style.maxBlockSize = '0px';
              void el.offsetHeight;
              el.style.maxBlockSize = h + 'px';
            }
          });

          if (hidden || reduced) return;
          // Release the caps once open so later content changes are not clipped.
          // A timer, not transitionend: a missed event would pin them to a stale
          // height for the rest of the session.
          focusTimer = setTimeout(function () {
            targets.forEach(function (el) { el.style.maxBlockSize = ''; });
          }, CAP_RELEASE_MS);
        }

        /* Which element actually scrolls. .page-wrapper takes over at >=990px
           (html/body are overflow:hidden there); the window scrolls on mobile.
           Never assume the window. */
        function scrollHost() {
          var pw = document.querySelector('.page-wrapper');
          if (pw && pw.scrollHeight > pw.clientHeight + 1) {
            var oy = getComputedStyle(pw).overflowY;
            if (oy === 'auto' || oy === 'scroll') return pw;
          }
          return window;
        }

        function scrollHostBy(host, dy) {
          if (!dy) return;
          if (host === window) window.scrollBy(0, dy);
          else host.scrollTop += dy;
        }

        /* ONE motion, not two.

           The earlier version held the builder still through the collapse (a
           per-frame counter-scroll) and THEN centred it. Those are two opposing
           moves: the counter-scroll pushes the page down, the centring pulls it
           back up. That is exactly what the user described — "it pushes the
           screen down first, then scrolls it back up and centers the multi-pack".

           Instead, predict the destination and go there once. The collapse
           removes a KNOWN height from above the builder, so its final position
           is arithmetic, not something to chase frame by frame. Starting that
           scroll at the same instant as the collapse means both animate together
           and read as a single glide, with no reversal.

           It also drops the per-frame getBoundingClientRect reads that were
           adding forced layouts on top of an already-reflowing height animation
           (the iPhone lag). */
        function centreOnce(el, spaceRemovedAbove) {
          var host = scrollHost();
          var vh = host === window ? window.innerHeight : host.clientHeight;
          var rect = el.getBoundingClientRect();

          // Where the element's top lands once the space above it is gone.
          var finalTop = rect.top - spaceRemovedAbove;
          // Where we want it: vertically centred, but never tucked under the
          // sticky header if the element is taller than the viewport.
          var wantedTop = Math.max((vh - rect.height) / 2, 72);

          var by = Math.round(finalTop - wantedTop);
          if (!by) return;

          if (host === window) window.scrollBy({ top: by, behavior: 'smooth' });
          else host.scrollTo({ top: host.scrollTop + by, behavior: 'smooth' });
        }

        function heightOfFocusTargets() {
          return focusTargets().reduce(function (sum, el) {
            return sum + el.getBoundingClientRect().height;
          }, 0);
        }

        /* Gated until a size is chosen, matching the pack tiles above (which dim
           under the same flag). Without this the builder is a dead end: opening
           it collapses the controls above and scrolls the size row off-screen, so
           a customer builds a pack, taps add, gets refused for having no size,
           and cannot see the size control to fix it.

           preventDefault on the summary stops <details> toggling at all, so the
           tap becomes the same "pick a size" prompt the main add-to-cart gives. */
        var summaryEl = bb.querySelector('summary');
        if (summaryEl) {
          summaryEl.addEventListener('click', function (e) {
            if (!document.documentElement.hasAttribute('data-nether-needs-size')) return;
            e.preventDefault();
            document.documentElement.setAttribute('data-nether-size-error', '');
            var grid = document.querySelector(
              '.product-details .variant-option--buttons:not([data-option-id$="-color"])'
            );
            if (grid) {
              grid.scrollIntoView({
                behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
                block: 'center'
              });
            }
          });
        }

        bb.addEventListener('toggle', function () {
          var open = bb.hasAttribute('open');
          var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var packs = document.querySelector('.product-details .bundle-picker');

          // Measure BEFORE the collapse starts — afterwards these are zero.
          var space = heightOfFocusTargets();

          document.documentElement.toggleAttribute('data-nether-bb-open', open);
          setFocusMode(open);

          // Desktop just expands in place — no collapse, so nothing to scroll to.
          if (!isCompact()) return;

          if (reduced) {
            (open ? bb : packs || bb).scrollIntoView({ behavior: 'auto', block: 'center' });
            return;
          }

          if (open) {
            // Space above is about to disappear, so the builder rises by `space`.
            centreOnce(bb, space);
            return;
          }

          /* Closing means "put the packs back", so the pack chooser is what gets
             centred — chasing the builder on the way out is what made the page
             run away. It has to wait for the cap release, though: setFocusMode
             clears the inline max-block-size at CAP_RELEASE_MS, and that last
             layout shift was landing mid-scroll and stranding it. */
          setTimeout(function () {
            (packs || bb).scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, CAP_RELEASE_MS + 60);
        });

        sync();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nether-colorway"] && !Shopify.designMode) return;
  try {
    (function () {
    // The chosen colour, tapped again: pulse its ring and show its first photo (see .is-pinged).
    function pingSelected(dot) {
      dot.classList.remove('is-pinged');
      void dot.offsetWidth;
      dot.classList.add('is-pinged');
      var show = document.querySelector('.product-information slideshow-component');
      if (show && show.getBoundingClientRect().width > 0 && typeof show.select === 'function') {
        // On a phone, nether-gallery-progress.js then scrolls the gallery into view, as it does for every
        // colour tap, so the shopper sees the photo come back to the first shot.
        try { show.select(0); } catch (e) {}
      }
    }

    function initColorway(root) {
      var blocks = (root || document).querySelectorAll('[data-nether-colorway]:not([data-cw-init])');
      blocks.forEach(function (cw) {
        cw.setAttribute('data-cw-init', 'true');
        var dots = cw.querySelectorAll('.nether-colorway__dot[data-colorway-value]');
        if (!dots.length) return;
        var nameEl = cw.querySelector('[data-colorway-name]');
        var details = cw.closest('.product-details') || document;

        // The dot swatch replaces the native colour option, so hide that
        // fieldset (found via its own radio inputs, not a fragile selector) to
        // avoid showing "Color" twice. The inputs stay in the DOM so the dots
        // can still drive the variant by clicking them.
        try {
          var firstVal = dots[0].getAttribute('data-colorway-value');
          var probe = details.querySelector('.variant-option input[type="radio"][value="' + (window.CSS && CSS.escape ? CSS.escape(firstVal) : firstVal) + '"]');
          var fs = probe && probe.closest('fieldset.variant-option');
          if (fs) fs.setAttribute('data-nether-cw-hidden', '');
        } catch (e) {}

        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            var val = dot.getAttribute('data-colorway-value');
            // Drive the real variant: click the matching (hidden) variant-picker input.
            var input = details.querySelector('.variant-option input[type="radio"][value="' + (window.CSS && CSS.escape ? CSS.escape(val) : val) + '"]');
            if (input && input.checked) pingSelected(dot);
            if (input && !input.checked) {
              input.checked = true;
              input.dispatchEvent(new Event('input', { bubbles: true }));
              input.dispatchEvent(new Event('change', { bubbles: true }));
              input.click();
            }
            // Optimistic UI sync.
            dots.forEach(function (d) { d.classList.remove('is-selected'); d.setAttribute('aria-checked', 'false'); });
            dot.classList.add('is-selected');
            dot.setAttribute('aria-checked', 'true');
            if (nameEl) nameEl.textContent = val;
          });
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () { initColorway(document); });
    document.addEventListener('shopify:section:load', function (e) { initColorway(e.target); });
    // Re-sync the active dot + label when the variant changes elsewhere.
    // (The accent colour tokens are handled by assets/nether-colorway.js.)
    function syncDots(optionValues) {
      document.querySelectorAll('[data-nether-colorway]').forEach(function (cw) {
        var nameEl = cw.querySelector('[data-colorway-name]');
        cw.querySelectorAll('.nether-colorway__dot[data-colorway-value]').forEach(function (d) {
          var match = optionValues.indexOf(d.getAttribute('data-colorway-value')) !== -1;
          d.classList.toggle('is-selected', match);
          d.setAttribute('aria-checked', match ? 'true' : 'false');
          if (match && nameEl) nameEl.textContent = d.getAttribute('data-colorway-value');
        });
      });
    }

    document.addEventListener('variant:selected', function (e) {
      var variant = e.detail && (e.detail.variant || e.detail.resource);
      if (!variant || !variant.options) return;
      syncDots(variant.options);
    });

    // Horizon 4.x: the platform Standard Event carries selectedOptions
    // [{name, value}] via a promise that settles after the section morph.
    document.addEventListener('shopify:product:select', function (e) {
      if (!e || !e.promise || typeof e.promise.then !== 'function') return;
      e.promise.then(function (result) {
        var variant = result && result.variant;
        if (!variant || !variant.selectedOptions) return;
        var values = variant.selectedOptions.map(function (o) {
          return o.value;
        });
        syncDots(values);
      }, function () {});
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nether-made-with"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-nether-mwb]:not([data-mwb-init])').forEach(function (wrap) {
        wrap.setAttribute('data-mwb-init', 'true');
        var openBtn = wrap.querySelector('[data-mwb-open]');
        var modalRoot = wrap.querySelector('[data-mwb-root]');
        if (!openBtn || !modalRoot) return;

        // Escape any stacking/clip context (same pattern as the size guide).
        if (modalRoot.parentElement !== document.body) document.body.appendChild(modalRoot);

        function onKey(e) {
          if (e.key === 'Escape') close();
        }
        var prevFocus = null;
        function open() {
          modalRoot.classList.add('is-open');
          modalRoot.setAttribute('aria-hidden', 'false');
          document.body.classList.add('nether-mwb-lock');
          // body overflow is a no-op at >=990px (.page-wrapper is the
          // scroller) — Horizon's scroll-lock attribute locks both.
          document.documentElement.setAttribute('scroll-lock', '');
          document.addEventListener('keydown', onKey);
          prevFocus = document.activeElement;
          var c = modalRoot.querySelector('.nether-mwb__close');
          if (c) c.focus();
        }
        function close() {
          // Restore focus FIRST: aria-hidden on an ancestor of the focused
          // close button gets blocked by the browser otherwise.
          if (prevFocus && typeof prevFocus.focus === 'function') prevFocus.focus();
          modalRoot.classList.remove('is-open');
          modalRoot.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('nether-mwb-lock');
          document.removeEventListener('keydown', onKey);
          document.documentElement.removeAttribute('scroll-lock');
        }

        openBtn.addEventListener('click', open);
        modalRoot.querySelectorAll('[data-mwb-close]').forEach(function (b) {
          b.addEventListener('click', close);
        });
      });
    }
    document.addEventListener('DOMContentLoaded', function () { init(document); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nether-pack-builder"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-nether-pack]:not([data-pb-init])').forEach(function (pb) {
        pb.setAttribute('data-pb-init', 'true');

        var segEl = pb.querySelector('[data-pb-seg]');
        var optsEl = pb.querySelector('[data-pb-options]');
        var buildEl = pb.querySelector('[data-pb-build]');
        var slotsEl = pb.querySelector('[data-pb-slots]');
        var hintEl = pb.querySelector('[data-pb-hint]');
        /* Retired 2026-08-12 with the stepper rework: the pack is built by the
           +/- controls on each colour row, so there is nothing left to confirm.
           Kept as a lookup rather than deleted outright because the listener and
           the focus-restore below both reference it, and a null is cheaper to
           guard than three call sites are to unpick. */
        var addBtn = pb.querySelector('[data-pb-addpack]');
        var unitEl = pb.querySelector('[data-pb-unit]');
        if (!segEl || !optsEl || !slotsEl) return;

        function readJson(sel, fb) {
          try { return JSON.parse(pb.querySelector(sel).textContent || ''); } catch (e) { return fb; }
        }
        var colors = readJson('[data-pb-colors]', []);
        /* One colour (Boxer Brief I): no cards to compose, the pack is N of it. */
        var single = pb.hasAttribute('data-pb-single');
        var variantMap = readJson('[data-pb-variantmap]', {});

        var unitPrice = parseInt(pb.getAttribute('data-pb-unit-price'), 10) || 0;
        var sizes = String(pb.getAttribute('data-pb-sizes') || '2,3,5')
          .split(',').map(function (s) { return parseInt(s, 10); }).filter(Boolean);
        var tierAQty = parseInt(pb.getAttribute('data-pb-tier-a-qty'), 10) || 0;
        var tierAPct = parseFloat(pb.getAttribute('data-pb-tier-a-pct')) || 0;
        var tierBQty = parseInt(pb.getAttribute('data-pb-tier-b-qty'), 10) || 0;
        var tierBPct = parseFloat(pb.getAttribute('data-pb-tier-b-pct')) || 0;
        var freeShip = parseInt(pb.getAttribute('data-pb-free-ship'), 10) || 0;
        // Cents, matching the threshold the announcement bar and cart both state.

        /* Original drawing, proportions corrected against a reference icon the
           owner sourced (not traced from it — the artwork is licensed and we do
           not hold the licence). What the reference taught: the waistband is a
           THIN band, about a tenth of the height, not the thick block v1 had;
           the legs run to just past half the height with a narrow notch between
           them; and the pouch is its own seam line, not implied. The pouch seam
           is the detail that makes it read as this product — it is the Valley
           Pouch, the thing the brand is named for.

           That seam is an OPEN U, not a closed oval (owner 2026-08-10: "you drew
           a circle within the pouch, but see here how the lines come up from the
           bottom of the boxer brief to the waistband"). Both ends terminate ON
           the band at y=16, because that is how the panel is actually cut: two
           seams running from the crotch up into the waistband, not a shape
           floating in the middle of the garment. A closed loop read as a logo. */
        var ICON =
          '<svg class="nether-pb__icon" viewBox="0 0 120 100" aria-hidden="true" focusable="false">' +
          '<path class="pb-body" d="M12 6 H108 C111 32 110 58 106 92 H74 C73 79 68 70 60 70 C52 70 47 79 46 92 H14 C10 58 9 32 12 6 Z"/>' +
          '<path class="pb-band" d="M12 6 H108 L107.1 16 H12.9 Z"/>' +
          '<path class="pb-seam" d="M38 16 C37 44 46 67 60 73 C74 67 83 44 82 16"/>' +
          '</svg>';

        var WORDS = { 2: 'two', 3: 'three', 4: 'four', 5: 'five', 6: 'six', 7: 'seven', 8: 'eight' };

        /* Lands on the SMALLEST size, so the page arrives quiet. Owner
           2026-08-10: "if they just stay on one, then nothing expands. They can
           go right to cart. This just keeps the page from being overwhelming."
           At 1 the widget is a pill and a button; the cards only exist once the
           customer opts into a pack. It used to open on 3 with a card already
           ticked, which both pre-answered the question and made the buy column
           roughly 240px taller before anyone had touched it. */
        /* NOTHING is pre-selected (owner, twice: "let's not pre-select a Choose
           Your Pack thing ... That's not fair to the customer", and again
           2026-08-12 on seeing 1 pair filled on arrival).

           This defaulted to sizes[0], which is 1 pair. The reasoning was that a
           single pair expands nothing, so the panel stayed quiet on landing.
           True, but it still arrived with a decision already made on the
           customer's behalf and a filled black tile asserting it. Quiet is not
           the same as unanswered.

           null means unanswered: no tile is filled, no cards render, and the
           button asks for a pack. Every comparison below is against a NUMBER,
           so null falls through all of them without a guard. */
        var size = null;
        /* -1 = nothing chosen. The page used to land with the first card already
           selected, which meant the button read "Add 3-pack to cart · C$122.55"
           before the customer had touched anything. Owner 2026-08-10: "let's not
           pre-select a Choose Your Pack thing... That's not fair to the
           customer." A default pack SIZE on the pill is merchandising; a
           pre-ticked pack is answering on their behalf. */
        var choice = -1;         // index into the generated option list
        /* ...and WHICH KIND that index refers to. options() changes shape with
           the pack size — One of Each only exists when the size equals the
           number of colourways — so an index alone does not survive a size
           change. The key does. */
        var choiceKey = 'solid';
        var custom = [];
        var armed = null;

        function colorInfo(n) {
          for (var i = 0; i < colors.length; i++) if (colors[i].name === n) return colors[i];
          return null;
        }
        function hexOf(n) { var c = colorInfo(n); return c ? c.hex : '#888'; }

        /* Is this colour buyable in the size the customer has actually chosen?

           colors[].available comes from Liquid's value.available, which is the
           OPTION value's flag: true if the colour exists in any size at all. It
           says nothing about the size on screen. variantMap is the real answer,
           because it is emitted only for variants where v.available is true, so
           a missing key is a definitive "not buyable".

           The picker used to test the option flag, so a colour sold out in L
           kept a live + button. You could build the whole pack, press Add, and
           only then be told -- by a message blaming the size rather than the
           colour. The stepper now refuses it up front.

           Before a size is chosen there is nothing to be specific about, so it
           falls back to the option flag, which is the honest answer at that
           point. render() re-runs on variant:selected, so picking or changing a
           size re-evaluates every row without any extra wiring. */
        function availableIn(name) {
          var sz = selectedSize();
          if (!sz) { var c = colorInfo(name); return !!(c && c.available); }
          return !!variantMap[name + '::' + sz];
        }

        /* A pack is ready only when every pair in it can be bought, not just when
           it holds enough pairs. Counting pairs alone let a pack with a sold-out
           colour (One of Each, the day Abyss went off sale, 2026-10-18) read
           "Add 3 pairs to cart", clear the gates, and spin for 8 s while submit()
           quietly refused it. */
        function packBuyable(p) {
          for (var i = 0; i < p.length; i++) if (!availableIn(p[i])) return false;
          return true;
        }

        /* The colourway the swatch row above has selected. Everything the
           customer sees here is built from it. */
        function galleryColor() {
          var dot = document.querySelector('.nether-colorway__dot.is-selected[data-colorway-value]');
          if (dot) return dot.getAttribute('data-colorway-value');
          return colors[0] ? colors[0].name : null;
        }
        function armedColor() { return armed || galleryColor(); }

        function selectedSize() {
          var i = document.querySelector(
            '.product-details .variant-option--buttons:not([data-option-id$="-color"]) input[type="radio"]:checked'
          );
          return i ? i.value : null;
        }

        /* THE SYMBOL COMES FROM LIQUID, NOT FROM THE PAGE (2026-09-07).

           This used to scan every .price in the document and take the prefix off
           the first one that looked like money. Measured on the live Roam PDP,
           that is five elements, the first is NOT the product's price, and two
           of them render as "$48.00" and "$43.00" with no C$ — they belong to
           the cart drawer and the search results. It returned "C$" only because
           a C$ one happened to sort first in document order.

           One reorder away, the pack ladder would have printed "$48 each pair"
           on a Canadian page. Same class of bug as the free-shipping bar reading
           a CAD threshold against a USD cart: currency inferred from whatever
           was lying around instead of stated.

           The variant price rendered through `money` is the authoritative
           answer and it is market-aware — C$ on /en-ca, US$ on /en-us — because
           Shopify formats it in the presentment currency. Note this relies on
           money's FORMATTING only, never its arithmetic: the amount here is
           thrown away and just the prefix is kept.

           The old scan stays as a fallback for the case where the attribute is
           missing, so a stale cached section cannot leave the ladder unpriced. */
        function currency() {
          var els = document.querySelectorAll('.price');
          for (var i = 0; i < els.length; i++) {
            var m = els[i].textContent.trim().match(/^([^\d]{0,4})[\d.,]+$/);
            if (m) return m[1];
          }
          return '$';
        }
        /* Whole dollars, always (owner 2026-08-13: "can we just use whole dollar
           amounts instead of adding the cents into it").

           This rounds UP, and the direction is the whole decision. The percent
           tiers here only MIRROR the automatic discounts in Shopify admin (see
           the schema note at the bottom of this file); Shopify computes what is
           actually charged. So 3 x C$43 less 5% is charged as C$122.55 whatever
           this button says, and the button is now a rounded version of it.

           Rounding down would print C$122 against a C$122.55 charge, which
           advertises a price the customer cannot have. Rounding up prints C$123
           and they pay 45c less than quoted. Only one of those two errors is
           safe to make, so the cents are dropped upward, never downward.

           The clean version of this is a discount that lands whole in the first
           place — a fixed C$6-off rather than 5% — and that lives in Shopify
           admin, not here. Until then this is a display rounding and the cart
           will still show the exact figure. */
        function money(c) {
          return currency() + Math.ceil(c / 100);
        }
        /* A SAVING ROUNDS THE OTHER WAY (2026-09-05, found on the move to
           C$48).

           money() rounds up, and the note above says why: a per-pair price the
           customer cannot actually get is the one error that matters, so the
           cents go upward and they pay a little less than quoted. That rule is
           correct and it stays. But it was also being spent on the SAVING, and
           a saving is the mirror case — it is the one figure in the row that
           promises a benefit rather than quotes a cost, so rounding it up
           advertises a discount the checkout does not give.

           At C$43 this never showed: 3 x 43 less 10% saved C$12.90 and printed
           C$13, 10c over. At C$48 the real saving is C$14.40 and the row was
           printing "Save C$15" — 60c of discount that does not exist.

           Same principle as money(), applied to a number that runs in the
           opposite direction: never state a price under what is charged, never
           state a saving over what is given. The 5-pack is untouched either way
           (15% of C$240 is exactly C$36). */
        function moneyDown(c) {
          return currency() + Math.floor(c / 100);
        }
        /* money2() IS GONE (owner 2026-08-26: "remove the cents... it just
           kind of looks unclean").

           It existed for two hours to keep the ladder readable as 43.00 /
           43.00 / 40.85 / 38.70. The owner would rather have 43 / 43 / 41 / 39,
           which is the same falling line without the decimal noise, and it puts
           the ladder back under the single whole-dollar rule money() already
           carries. Rounding stays upward, so a quoted per-pair price is never
           under what Shopify charges. */
        /* THE VIEW FOLLOWS THE CUSTOMER (owner 2026-08-26: "each button push
           should shift/follow the path of the customer... it just has to centre
           each action", refined to "as long as everything keeps coming down so
           that the checkout button stays within reach the whole way through").

           Four rules keep it from becoming the auto-scroll people hate:

           1. NOTHING MOVES IF THE TARGET IS ALREADY COMFORTABLY PLACED.
              Scrolling something the customer can already see steals the
              position they chose. The 8px margin is part of that test: a
              control flush against the bottom of the glass is not reachable,
              so flush does not count as visible.
           2. A target taller than most of the screen aligns to its START.
              Centring one of those pushes its top off the top of the screen,
              which is worse than not scrolling at all.
           3. It only ever runs from a real tap. Never on load, never on render.
           4. prefers-reduced-motion gets the jump, not the glide. Smooth
              scrolling is a documented migraine and vestibular trigger.

           settleMs is the wait before measuring, because the thing being
           scrolled to was created by the same click. 60ms is enough for a card
           swap; a panel that unhides and then fills needs longer, or it gets
           measured while it is still small enough to pass rule 1. */
        function follow(el, settleMs) {
          if (!el) return;
          setTimeout(function () {
            var r = el.getBoundingClientRect();
            if (!r.height) return;

            /* IN THE BUY SHEET THE SHEET FOLLOWS, NOT THE PAGE (2026-09-25).
               The steps live in nether-buy-sheet's own scrolling box while it
               is open, so moving the window only moved the page behind the
               sheet and left the sheet where it was (owner: the sheet should
               behave "the exact same way as the product page where it will
               auto scroll the steps", and the page below should not move).
               Same four rules, measured against the sheet's box instead of
               the glass: its top, and the top of its pinned buy button. */
            var sheetBox = el.closest ? el.closest('.nether-buy-sheet__body') : null;
            if (sheetBox) {
              /* WAIT FOR THE ROOM (same night: a pack chosen in the sheet
                 opened its options under the pinned button and the sheet
                 moved 45px, owner: "the sheet doesn't automatically scroll,
                 so you can't really see the bundle build"). A smooth scroll is
                 capped at the scroll range it starts with, and the sheet's
                 range is still growing when the options first measure: 45px
                 of room at the tap, 240px once they have opened. The window
                 never hit this because a page always has room to spare. So
                 while the target lies past the room there is, wait for the
                 room, 60ms at a time and 480ms at most, then make the one
                 smooth scroll. Waiting stops early once the room has stopped
                 growing, so a target that is simply near the end is not held
                 for the full 480ms. */
              var tries = 0;
              var lastRoom = -1;
              var go = function () {
                var er = el.getBoundingClientRect();
                var sb = sheetBox.getBoundingClientRect();
                var pinned = sheetBox.querySelector('.buy-buttons-block');
                var seeTop = sb.top;
                var seeBottom = pinned && !pinned.contains(el) ? Math.min(sb.bottom, pinned.getBoundingClientRect().top) : sb.bottom;
                var seeH = seeBottom - seeTop;
                if (er.top >= seeTop + 8 && er.bottom <= seeBottom - 8) return;
                var into = er.height > seeH * 0.8
                  ? sheetBox.scrollTop + er.top - seeTop - 8
                  : sheetBox.scrollTop + er.top - seeTop - (seeH - er.height) / 2;
                var room = sheetBox.scrollHeight - sheetBox.clientHeight;
                if (into > room + 1 && tries < 8 && room !== lastRoom) {
                  lastRoom = room;
                  tries++;
                  setTimeout(go, 60);
                  return;
                }
                var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                sheetBox.scrollTo({ top: Math.max(0, Math.min(into, room)), behavior: still ? 'auto' : 'smooth' });
              };
              go();
              return;
            }

            /* MEASURE THE VISUAL VIEWPORT, NOT THE LAYOUT ONE (owner 2026-09-07:
               "is there anything that can be done with the Instagram in-app
               browser to make sure things get centered when scrolling
               through?").

               window.innerHeight is the LAYOUT viewport. In the Instagram and
               Facebook in-app browsers — which is where most of the paid traffic
               lands — that number includes the strip sitting behind the bottom
               toolbar, and on iOS Safari it includes the collapsing address bar.
               So the midpoint this used was lower than the real midpoint, and a
               control "centred" by it drifted toward, and sometimes under, the
               chrome. The in-view test was wrong the same way: an element tucked
               behind the toolbar passed `r.bottom <= vh - 8` and follow() then
               declined to move at all.

               visualViewport.height is the actually-visible area, and offsetTop
               is where it starts inside the layout viewport (non-zero while
               pinch-zoomed or mid toolbar animation). Both fall back to the old
               reads on anything that lacks the API. */
            var vv = window.visualViewport;
            var vh = (vv && vv.height) || window.innerHeight || document.documentElement.clientHeight;
            var vTop = (vv && vv.offsetTop) || 0;

            if (r.top >= vTop + 8 && r.bottom <= vTop + vh - 8) return;

            /* scrollIntoView centres against the LAYOUT viewport, so it
               reintroduces the same error this just corrected. The scroll is
               computed here instead: put the element's centre on the visible
               area's centre, or its top at the visible top when it is too tall
               to centre without pushing its head off screen. */
            var y = window.scrollY || window.pageYOffset || 0;
            var target = r.height > vh * 0.8
              ? y + r.top - vTop - 8
              : y + r.top - vTop - (vh - r.height) / 2;
            if (target < 0) target = 0;

            var reduce = window.matchMedia &&
              window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            try {
              window.scrollTo({ top: target, behavior: reduce ? 'auto' : 'smooth' });
            } catch (e) {
              window.scrollTo(0, target);
            }
          }, settleMs || 60);
        }

        /* The buy button belongs to the PDP, not to this block, so it is looked
           up rather than held: Horizon replaces that subtree on every variant
           change, and a cached reference would go stale on the first size tap.
           Null is fine, follow() no-ops. */
        function buyButton() {
          return document.querySelector('[name="add"], .product-form__submit');
        }

        function pctFor(n) {
          if (tierBQty && n >= tierBQty) return tierBPct;
          if (tierAQty && n >= tierAQty) return tierAPct;
          return 0;
        }
        function totalFor(n) { return Math.round(unitPrice * n * (100 - pctFor(n)) / 100); }

        function describe(mix) {
          var counts = {}, order = [];
          mix.forEach(function (c) {
            if (!counts[c]) { counts[c] = 0; order.push(c); }
            counts[c]++;
          });
          if (order.length === mix.length) return order.join(', ');
          return order.map(function (c) { return counts[c] + ' ' + c; }).join(', ');
        }

        /* Generated, never authored. One solid pack of whatever is selected
           above, a one-of-each only where the pack size equals the number of
           colourways, then Build your own. */
        function options() {
          var g = galleryColor();
          var list = [];

          /* A single pair has nothing to compose: the colour is whatever the
             swatches upstairs have selected, so a "Midnight one" card and a
             "Build your own" of one would both be asking a question with one
             answer. Owner 2026-08-10: "How would a customer just do one pair?
             ...It shouldn't be confusing if they don't want to get two or three
             or five." At size 1 the widget collapses to the pill and the button,
             which is how every ordinary PDP behaves. */
          /* Nothing chosen yet, or a single pair: no composition to make. null
             is the untouched state, 1 is a pair whose colour the swatches
             upstairs already decided. */
          if (!size || size === 1 || single) return list;

          /* The solid card is the swatch colour, so it is only offered when that
             colour can be bought (2026-10-18: tapping the sold-out Abyss swatch
             produced a preselected "3 × Abyss"). With no solid card nothing is
             preselected and the button asks for colours; see resolveChoice. */
          var solid = [];
          for (var i = 0; i < size; i++) solid.push(g);
          if (availableIn(g)) {
          /* "3 Midnight", and nothing underneath. It read "Midnight three" over
             "3 Midnight" — the same fact twice, once in words and once in
             figures (owner 2026-08-10: "not be shown twice"). The other two
             cards keep a subtitle because theirs adds something the title does
             not: which colours, or how many you still pick. */
          list.push({
            key: 'solid',
            /* "3 x Midnight", not "3 Midnight" (owner 2026-08-12). Without the
               multiplier the number reads as part of the colour name rather than
               a quantity, and this is the one card where the count is the whole
               difference between it and the others. The bubbles now say it too;
               this says it in text, for anyone the colours do not reach. */
            name: size + ' × ' + g,
            sub: '',
            mix: solid
          });
          }
          /* One of Each only while every colourway can actually be bought in the
             chosen size. With Abyss off sale (2026-10-18) a 3-pack can no longer be
             one of each, so the card goes, and it comes back by itself when every
             colour is in stock again. It is not rebuilt from the colours that are
             left: a "Midnight, Storm" card would move onto the 2-pack, which is a
             merchandising call for the owner, not a stock rule. */
          if (size === colors.length && colors.length > 1 && colors.every(function (c) { return availableIn(c.name); })) {
            list.push({
              key: 'mixed',
              name: 'One of Each',
              sub: colors.map(function (c) { return c.name; }).join(', '),
              mix: colors.map(function (c) { return c.name; })
            });
          }
          list.push({
            key: 'custom',
            name: 'Build Your Own',
            sub: '',
            mix: null
          });
          return list;
        }

        function pack() {
          // Size 1 renders no cards, so the pack IS the selected colourway.
          if (size === 1) {
            var g1 = galleryColor();
            return g1 ? [g1] : [];
          }
          if (single) {
            var gs = galleryColor(), ps = [];
            for (var si = 0; gs && si < size; si++) ps.push(gs);
            return ps;
          }
          if (choice < 0) return [];
          var o = options()[choice];
          if (!o) return [];
          return o.key === 'custom' ? custom : o.mix;
        }

        /* The bleeding gradient band this replaced was asked for on 2026-08-10
           ("the stripes for the colors can kind of bleed into each other so they
           look a lot nicer") and withdrawn on 2026-08-12 ("not sure if i like
           the gradient look", "swatch bubbles look nicer"). Kept here as the
           reason bandFor no longer interpolates: the blend that made two colours
           read as one transition is exactly what stopped a 3-pack and a 5-pack
           looking different from each other. */

        /* One bubble per pair, not a gradient band (owner 2026-08-12: "swatch
           bubbles look nicer", "not sure if i like the gradient look").

           The bubbles are the same object as the colourway swatches sitting a
           few rows above in this column: flat colour, 1px hairline ring, no
           sheen. Reusing that treatment rather than inventing a second one is
           the same "one control language" rule the pack tiles now follow.

           The old band was a single 48px rounded square carrying a linear
           gradient across N colour stops. It had two problems. It blended at
           every interior edge, so a 3-pack and a 5-pack looked almost identical,
           and it never stated the COUNT: you had to read the label to learn how
           many pairs you were buying. Bubbles say it by being countable.

           The gradient's stated job was legibility, on the grounds that three
           near-blacks need a sheen to tell apart. The swatch row above disproves
           that: it runs the same three hexes flat and they read fine, because
           the colours genuinely differ. The sheen was solving a problem the
           blending created. */
        function bandFor(mix, total) {
          var wrap = document.createElement('span');
          wrap.className = 'nether-pb__band';
          if (!total) return wrap;

          for (var i = 0; i < total; i++) {
            var dot = document.createElement('span');
            dot.className = 'nether-pb__dot';
            var c = mix && mix[i] ? hexOf(mix[i]) : '';
            if (c) {
              dot.style.backgroundColor = c;
            } else {
              // An unfilled slot in a part-built pack. Reads as a gap to fill
              // rather than a colour, which is what it is.
              dot.setAttribute('data-empty', '');
            }
            wrap.appendChild(dot);
          }
          if (!mix || !mix.length) wrap.setAttribute('data-empty', '');
          return wrap;
        }

        /* Turn a remembered KIND back into an index in the CURRENT option list.

           options() is regenerated per pack size and does not always contain the
           same cards, so this is the only safe way to carry a composition across
           a size change. Anything unresolvable falls to 0, which is always the
           solid pack in the colourway the customer picked upstairs — never a
           guess, just their own selection echoed back. Size 1 has no
           composition at all, so it returns -1 and the cards stay away. */
        function resolveChoice(key) {
          var list = options();
          for (var i = 0; i < list.length; i++) {
            if (list[i].key === key) return i;
          }
          /* Index 0 is only a safe default when it is the solid card. When the
             swatch colour is sold out there is no solid card and index 0 would be
             a mix or Build Your Own picked for the customer, so nothing is chosen. */
          return list.length && list[0].key === 'solid' ? 0 : -1;
        }

        function renderSeg() {
          segEl.style.setProperty('--pb-n', sizes.length);
          segEl.textContent = '';
          /* What you GAIN at each step, on the tile that offers it. Free
             shipping is announced on the first tier that actually clears the
             threshold and has nothing better to say: at C$43 a pair, two pairs
             is C$86 against a C$75 bar. Three and five clear it too, but they
             have a discount to announce, and a tier should name the NEW thing
             it brings rather than repeat the last one.
             This is the same rule the deleted ladder row used. Only its
             location changed. */
          sizes.forEach(function (n) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'nether-pb__segbtn';
            b.setAttribute('role', 'radio');
            b.setAttribute('aria-checked', n === size ? 'true' : 'false');

            /* PRICE PER PAIR LEADS (owner 2026-08-26: "have the total price
               on the right just be per pair, then the subtext is the total").

               The tiles used to say "3 pairs / Save 5%" and no money at all: a
               percentage of a number this control never showed. To learn that
               three pairs cost anything you had to select it and look at the
               button.

               Per pair is the figure the decision actually turns on, and
               putting it in the right-hand column stacks the four rows into one
               falling number. The total moves to the subtext because it is the
               number that frightens people — the ladder's job is to make buying
               more feel cheaper, and a column of totals does the opposite. */
            var head = document.createElement('span');
            head.className = 'nether-pb__segname';
            var nm = document.createElement('span');
            nm.textContent = n === 1 ? '1 pair' : n + ' pairs';
            head.appendChild(nm);

            /* The flag rides the tier the shop actually wants to sell rather
               than a hardcoded 3, so changing tier_a_quantity in the editor
               moves it. It says out loud what the discount was hinting. */
            if (tierAQty && n === tierAQty) {
              var flag = document.createElement('span');
              flag.className = 'nether-pb__segflag';
              flag.textContent = 'Most popular';
              head.appendChild(flag);
            } else if (!(unitPrice * n - totalFor(n)) && freeShip && totalFor(n) >= freeShip) {
              /* FREE SHIPPING, as a flag beside the pair count like Most popular
                 (owner 2026-09-25: "Put free shipping beside the pair amount like
                 the most popular one"). Same rule as it had as a line under the
                 price, see the note further down: a pack with no saving to state
                 whose total clears the bag's own threshold, which today is the
                 2-pack alone. */
              var shipFlag = document.createElement('span');
              shipFlag.className = 'nether-pb__segflag';
              shipFlag.textContent = 'Free shipping';
              head.appendChild(shipFlag);
            }
            b.appendChild(head);

            var unit = document.createElement('span');
            unit.className = 'nether-pb__segunit';
            unit.textContent = money(Math.ceil(totalFor(n) / n));
            var per = document.createElement('small');
            per.className = 'nether-pb__segper';
            /* "each pair", not "a pair" (owner 2026-09-05). On a ladder where
               every row is a different pack size, "C$44 a pair" reads as one
               indefinite pair; "each pair" says the price applies to all three
               of them, which is the thing the row is actually claiming. */
            per.textContent = 'each pair';
            unit.appendChild(per);
            b.appendChild(unit);

            /* NO TOTALS ON THE PAGE (owner 2026-08-26: "I just don't want to
               have US$149 on the page... it should just be the per-pair amount
               everywhere, and then the small subtle text should be the
               discounted one").

               The total was the second thing in every row and the loudest
               argument against the pack it was attached to: "5 pairs" reads as a
               deal until "US$149 total" reads as a lot of money. Someone
               choosing a five-pack has already decided they want five pairs, so
               the page's job is to price a pair and get out of the way. The bill
               is the cart's sentence to say, and the cart says it exactly,
               unrounded.

               What is left under each row is the only thing that changes between
               them apart from the per-pair price: what this tier saves. Rows
               with nothing to say get no line at all rather than an empty one. */
            var saved = unitPrice * n - totalFor(n);
            var bits = [];
            if (saved > 0) {
              bits.push('Save ' + moneyDown(saved));
            }

            /* THE FREE-SHIPPING BADGE IS GONE FROM THE LADDER (owner
               2026-08-26).

               It only ever landed on ONE tier: the first that cleared C5
               without a discount to announce. At C3 a pair that is TWO pairs
               (C6), and in CAD it was the only badge above the fold.

               A badge that says "free shipping starts here" is a finish line.
               Every tier above it ships free as well, so the badge was not
               information — it was a cap, marking 2 pairs as the point where
               paying more stops buying anything. The AOV sitting near C1,
               which is almost exactly two pairs, is what that looks like in the
               numbers.

               The offer itself is unchanged and still stated twice: the
               announcement bar and the trust cards under the buy button. What
               is removed is the per-tier flag that turned it into a target.
               The only badge on the ladder now is MOST POPULAR, on the tier the
               shop actually wants to sell. */

            /* ...AND BACK ON THE 2-PACK, 2026-09-25 (owner: "add the free
               shipping into the 2 pack button. Most of my customers are
               Canadian"). He made this call knowing the 08-26 reasoning above:
               two pairs showed $48 each with no saving, so a hesitant buyer had
               no reason to go from one pair to two. It went in as a line under
               the price and moved beside the pair count the same night, as a
               flag like Most popular (his call on the second look).

               Driven by the numbers, not by the row: a pack with no saving to
               state whose total clears the bag's own free-shipping threshold
               says so. With today's prices that is the 2-pack alone, in Canada
               (C$96 against C$75) and in the US (US$96 against the bar's US$95;
               the delivery profile's real line is C$125, about US$92.60). If a
               price or the threshold moves, the line moves with it, so the page
               never promises free shipping the cart will not give.

               It lives beside the pair count now, as a flag like Most popular
               (same night, his second look), so it is built with the row's head
               above rather than pushed onto this line. */

            if (bits.length) {
              var sub = document.createElement('span');
              sub.className = 'nether-pb__segsub';
              sub.textContent = bits.join(' · ');
              b.appendChild(sub);
            }

            b.addEventListener('click', function () {
              size = n;
              custom = [];
              /* Changing the pack size clears the composition. It must.

                 `choice` is an INDEX into options(), and that list changes
                 shape with the size: "One of Each" only exists when the pack
                 size equals the number of colourways, so with three colours
                 index 1 is One of Each at 3 but Build Your Own at 2 and 5.
                 Carrying the raw index across a size change therefore does not
                 carry the selection, it reassigns it.

                 This line used to read `if (choice >= options().length)
                 choice = 0;`, which made both halves of that wrong:

                 - Build your own 5, switch to 3. The index survives the bounds
                   test, so the selection lands on One of Each, and because that
                   card is a complete composition the buy button arms itself
                   reading "Add 3-pack to cart". A customer who built a pack
                   they chose is handed one they did not.
                 - Build your own 3 (index 2), switch to 5. Out of range, so it
                   snapped to 0, the solid card, and armed just the same.

                 Both silently swap what is being bought, and the owner has
                 asked twice that nothing be selected on the customer's behalf.
                 -1 is the untouched state, so the pack has to be chosen again,
                 which for a hundred-plus dollar order is the right ask. */
              /* PRESELECT THE PACK THE COLOURWAY ALREADY DESCRIBES (owner
                 2026-08-26: "if they chose two pairs it preselected the two
                 times the colour they chose in the gallery").

                 This used to clear to -1, which meant the customer had to tap a
                 card that only restated the colourway they had already picked
                 upstairs — at two pairs the choice was literally "2 x Abyss" or
                 "build something else", so the first option was a no-op
                 confirmation standing between them and the buy button.

                 It is NOT the thing the long note below warned about. That was
                 about carrying a stale INDEX across a size change and silently
                 arming a different composition. Resolving by KEY cannot do that:
                 a customer on Build Your Own stays on Build Your Own with empty
                 slots and the mix gate still holding, and anyone whose key no
                 longer exists at the new size lands on solid, which is by
                 definition the colourway they chose themselves. */
              choice = resolveChoice(choiceKey);
              render();
              /* Pack chosen: the next thing to do is pick colours, and the
                 cards for it were just created below the fold. */
              follow(optsEl);
            });
            segEl.appendChild(b);
          });

        }

        function renderOptions() {
          optsEl.textContent = '';
          /* No cards at size 1: options() returns an empty list there, which is
             what keeps the page from expanding until a pack is actually chosen.
             Deliberately NOT also gated on size being selected — tapping "3
             pairs" and watching nothing happen reads as broken. The cards open,
             and the button is the thing that says a size is still needed. */
          var list = options();
          list.forEach(function (o, i) {
            var input = document.createElement('input');
            input.type = 'radio';
            input.name = 'nether-pb-opt';
            input.className = 'nether-pb__radio';
            input.id = 'pb-opt-' + i;
            input.checked = i === choice;
            input.addEventListener('change', function () {
              choice = i;
              choiceKey = o.key;
              render();
              /* Build your own opens a drawer and the pack is not finished, so
                 the next action is in that drawer. Every other card completes
                 the pack, so the next action is buying it. */
              /* 300ms for the drawer, 60 for everything else. Build Your Own
                 unhides a panel that then fills with slots and a colour picker,
                 and at 60ms it was still short enough to fit the screen — so the
                 in-view test passed, follow() returned, and nothing moved while
                 the buy button was quietly pushed under the fold (owner
                 2026-08-26: "I hit Build Your Own and it didn't auto-expand and
                 drag the viewport down"). Measure the drawer once it is the size
                 it is actually going to be. */
              if (o.key === 'custom') follow(buildEl, 300);
              else follow(buyButton());
            });

            var label = document.createElement('label');
            label.className = 'nether-pb__opt';
            label.setAttribute('for', input.id);

            label.appendChild(bandFor(o.key === 'custom' ? custom : o.mix, size));

            var body = document.createElement('span');
            body.className = 'nether-pb__opt-body';
            var nm = document.createElement('span');
            nm.className = 'nether-pb__opt-name';
            nm.textContent = o.name;
            body.appendChild(nm);
            // The solid pack ships no subtitle, so do not leave an empty line
            // holding its space under the title.
            //
            // "Build Your Own" no longer carries its static subtitle either.
            // "Choose each of the three pairs" was an instruction restating the
            // card's own name, and it was the one genuinely redundant line in
            // the panel. Once pairs ARE picked the same slot states what is in
            // the pack, which is a fact rather than a direction.
            //
            // One of Each KEEPS its subtitle. That line is the only place the
            // pack contents are named, so dropping it would leave the customer
            // tapping blind on the option most likely to be tapped.
            var subText = o.key === 'custom' ? (custom.length ? describe(custom) : '') : o.sub;
            if (subText) {
              var sb = document.createElement('span');
              sb.className = 'nether-pb__opt-sub';
              sb.textContent = subText;
              body.appendChild(sb);
            }
            label.appendChild(body);

            /* No price on the cards. All options at one pack size cost the
               same, so a price column printed the identical figure three times
               (owner: "fix the pack thing"). The pack tiles above carry the
               saving and the button below carries the total, so each figure is
               stated exactly once. */

            optsEl.appendChild(input);
            optsEl.appendChild(label);
          });
        }

        function renderSlots() {
          slotsEl.style.setProperty('--pb-max', size);
          slotsEl.textContent = '';
          for (var i = 0; i < size; i++) {
            var slot = document.createElement('div');
            slot.className = 'nether-pb__slot';
            slot.setAttribute('role', 'listitem');
            slot.insertAdjacentHTML('afterbegin', ICON);
            var name = custom[i];
            if (name) {
              slot.setAttribute('data-filled', '');
              slot.style.setProperty('--pb-dot', hexOf(name));
              slot.setAttribute('aria-label', name);
              var x = document.createElement('button');
              x.type = 'button';
              x.className = 'nether-pb__x';
              x.setAttribute('aria-label', 'Remove ' + name);
              x.textContent = '×';
              (function (idx) {
                x.addEventListener('click', function () { custom.splice(idx, 1); render(); });
              })(i);
              slot.appendChild(x);
            } else {
              slot.setAttribute('aria-label', 'Empty slot ' + (i + 1));
            }
            slotsEl.appendChild(slot);
          }
        }

        function renderPicker() {
          var el = pb.querySelector('[data-pb-picker]');
          if (!el) return;
          el.textContent = '';
          /* One stepper per colour. Owner 2026-08-12: "it seems like there's an
             extra click that has to happen ... it should just be a variant or a
             picker on the right-hand side, so you can just add + or -".

             This was arm-then-confirm: tap a colour to arm it, then tap "Add
             Midnight to pack" below, then scroll back up for the next one. Two
             taps and a round trip PER PAIR, so a 5-pack cost ten taps and four
             trips down and back. The stepper is direct: + puts one in, - takes
             one out, and the count is on the row that owns it. A 5-pack of one
             colour is now five taps in one place, and mixing is the same
             gesture. Nothing to arm, so nothing to forget you armed. */
          var total = custom.length;
          colors.forEach(function (c) {
            var row = document.createElement('div');
            row.className = 'nether-pb__pick';
            row.style.setProperty('--pb-dot', c.hex || '#888');
            if (!availableIn(c.name)) row.setAttribute('data-unavailable', '');

            var dot = document.createElement('span');
            dot.className = 'nether-pb__pick-dot';
            var nm = document.createElement('span');
            nm.className = 'nether-pb__pick-name';
            /* The dimmed row needs its reason in words: these colours are
               near-blacks, so tint alone does not say "sold out" (2026-10-18). */
            nm.textContent = availableIn(c.name) ? c.name : c.name + ' · Sold out';

            var count = 0;
            for (var i = 0; i < custom.length; i++) if (custom[i] === c.name) count++;
            if (count > 0) row.setAttribute('data-has', '');

            var step = document.createElement('span');
            step.className = 'nether-pb__step';

            var minus = document.createElement('button');
            minus.type = 'button';
            minus.className = 'nether-pb__stepbtn';
            minus.setAttribute('aria-label', 'Remove one ' + c.name);
            minus.textContent = '−';
            minus.disabled = count === 0;
            minus.addEventListener('click', function () {
              var at = custom.lastIndexOf(c.name);
              if (at > -1) custom.splice(at, 1);
              render();
            });

            var num = document.createElement('span');
            num.className = 'nether-pb__stepnum';
            num.textContent = String(count);

            var plus = document.createElement('button');
            plus.type = 'button';
            plus.className = 'nether-pb__stepbtn';
            plus.setAttribute('aria-label', 'Add one ' + c.name);
            plus.textContent = '+';
            /* Capped at the pack size, so the widget cannot build a pack the
               cart would refuse. The hint below says how many are left. */
            plus.disabled = !availableIn(c.name) || total >= size;
            plus.addEventListener('click', function () {
              if (custom.length < size) { custom.push(c.name); render(); }
            });

            step.appendChild(minus);
            step.appendChild(num);
            step.appendChild(plus);
            row.appendChild(dot);
            row.appendChild(nm);
            row.appendChild(step);
            el.appendChild(row);
          });
        }

        /* Every render rebuilds these containers from scratch, which destroys the
           focused node and drops focus to <body>. A keyboard or switch user lost
           their place on EVERY press: tab to "3 pairs", hit it, and focus is gone
           from the widget entirely. Remember the focused control, restore it once
           the rebuild lands. */
        function focusKey() {
          var a = document.activeElement;
          if (!a || !pb.contains(a) || !a.closest) return null;
          if (a.hasAttribute('data-pb-addpack')) return '[data-pb-addpack]';
          var seg = a.closest('.nether-pb__segbtn');
          if (seg) {
            var segs = segEl.querySelectorAll('.nether-pb__segbtn');
            return { sel: '.nether-pb__segbtn', i: [].indexOf.call(segs, seg) };
          }
          var pick = a.closest('.nether-pb__pick');
          if (pick) {
            var picks = pb.querySelectorAll('.nether-pb__pick');
            return { sel: '.nether-pb__pick', i: [].indexOf.call(picks, pick) };
          }
          if (a.classList.contains('nether-pb__radio')) return { sel: '.nether-pb__radio', i: a.id };
          return null;
        }

        function restoreFocus(k) {
          if (!k) return;
          var el;
          if (typeof k === 'string') el = pb.querySelector(k);
          else if (typeof k.i === 'string') el = pb.querySelector('#' + k.i);
          else el = pb.querySelectorAll(k.sel)[k.i];
          if (el && el.focus) el.focus({ preventScroll: true });
        }

        function render() {
          var keepFocus = focusKey();
          /* The card list now changes with stock (2026-10-18): the solid card goes
             when the swatch colour is sold out, One of Each when any colour is.
             `choice` is an INDEX into that list, so a swatch or size change could
             leave it pointing at a different card (3 × Midnight ticked, tap Abyss,
             the tick moved to Build Your Own). Re-find the card by its kind; if
             the kind is gone nothing is ticked, and it comes back when it does. */
          if (size > 1) {
            var curOpts = options();
            if (!curOpts[choice] || curOpts[choice].key !== choiceKey) {
              choice = -1;
              for (var ci = 0; ci < curOpts.length; ci++) {
                if (curOpts[ci].key === choiceKey) { choice = ci; break; }
              }
            }
          }
          /* Publish whether the pack is whole. Tied to render() rather than to
             each control because every path that can change the answer — a size
             tile, a colour card, a stepper, a colourway swap upstairs — ends
             here, and a flag hung off one of them would go stale after the
             others.

             data-nether-mix-incomplete is not a new invention: nether-pdp.liquid
             already reads it in two places and describes it, in its own words,
             as "a colour pack builder that isn't filled". Nothing was setting it
             on this template, though — the only writer is
             bundle-quantity-picker, which lives on product.json while this block
             lives on product.multicolor.json, so the two never meet and the flag
             was simply never raised here.

             That silence is what put the success burst on a refused press
             (owner 2026-08-13: "the burst animation shouldn't be until the very
             last thing, with a successful product being added to the cart").
             The add-to-cart sequencer already declines to animate a gated tap —
             `if (atcRoot.hasAttribute('data-nether-mix-incomplete')) return;` —
             it was just never told. Raising the flag it already watches is the
             fix; reaching for stopImmediatePropagation from this block would
             have fought that contract instead of using it, and would also have
             killed the size-error handler that rides the same event.

             It buys the sticky bar too: the second reader strips on:click while
             this is set, so Horizon cannot paint its own false checkmark on a
             blocked tap. */
          /* Named html, not root: init() takes a parameter called root that
             means the section subtree being initialised, and a nested shadow of
             it meaning the opposite scope is a trap for whoever edits next. */
          var html = document.documentElement;

          /* TWO GATES, TWO FLAGS — they used to share one condition, which is
             the bug the owner hit on 2026-08-23: "even though the pack was
             chosen, it still got lit up with red".

             data-nether-pack-error means "you have not picked a pack size".
             data-nether-mix-incomplete means "you have not finished picking
             colours". They fail at different moments and clear at different
             moments, but this cleared pack-error only when the WHOLE mix was
             complete. So choosing 2 pairs and not yet choosing the two colours
             left the row outlined in red under a message reading "Choose a pack
             size." — pointing at the one control that was already satisfied.

             The pack error now answers only its own question. The colour gap is
             mix-incomplete's job and still blocks the add. */
          if (size) html.removeAttribute('data-nether-pack-error');

          if (size && pack().length >= size && packBuyable(pack())) {
            html.removeAttribute('data-nether-mix-incomplete');
          } else {
            html.setAttribute('data-nether-mix-incomplete', '');
          }
          /* The header's "per pair" line stays retired. It said the same thing
             the price above the buy area already says, two lines apart. */
          if (unitEl) unitEl.textContent = '';
          renderSeg();
          renderOptions();

          var isCustom = (options()[choice] || {}).key === 'custom';
          buildEl.hidden = !isCustom;
          if (isCustom) {
            renderSlots();
            renderPicker();
            var n = custom.length;
            if (hintEl) {
              var left = size - n;
              hintEl.textContent = left > 0
                ? left + (left === 1 ? ' pair left to choose.' : ' pairs left to choose.')
                : (pctFor(size) ? pctFor(size) + '% off applied.' : '');
            }
          }
          syncMainButton();

          /* THE REVEAL NEEDS A REAL DISTANCE TO TRAVEL (owner 2026-08-26: "the
             animation is super snappy, it needs a little more grace").

             The collapse in nether-pdp.liquid animates max-block-size, and a cap
             set to a safe-but-huge 160rem means the visible growth is over in the
             first ~12% of the duration — the element hits its real ~300px and the
             remaining 2200px of cap keeps animating with nothing to show. Slowing
             the transition would not have fixed that; it would have stretched the
             dead part.

             Publishing the exact content height turns the same 400ms into 400ms
             of visible travel. Re-measured on every render because each step
             makes the block taller, and scrollHeight reads true even while the
             element is collapsed.

             Except when the block is display:none: the all-out state hides it
             while a colour is sold out in every size (2026-10-18), and there
             scrollHeight is 0. Publishing that 0 kept the ladder at zero height
             after switching back to a colour with stock. So a 0 reading drops
             the cap (CSS falls back to 160rem) and the next render measures. */
          var capH = pb.scrollHeight;
          if (capH > 0) pb.style.setProperty('--nether-pb-cap', capH + 'px');
          else pb.style.removeProperty('--nether-pb-cap');

          restoreFocus(keepFocus);
        }

        function mainButton() {
          return document.querySelector(
            '.product-details .buy-buttons-block button[type="submit"], ' +
            '.product-details product-form-component button[type="submit"]'
          );
        }
        var mainDefault = null;

        /* Find the thing that holds the button's words, WITHOUT taking the
           button itself as a fallback.

           Horizon 4.1.1 wrapped the label in .add-to-cart-text. 4.1.4 removed
           that wrapper: the label is now a BARE TEXT NODE sitting between the
           icon span and the checkmark-burst span. The old code fell back to the
           button element and wrote button.textContent, which does not just
           replace the words, it deletes every child. The icon and the burst
           span were destroyed on first render, and the button ended up with a
           doubled, overlapping label (owner 2026-08-12, on live).

           Measured after the 4.1.4 merge: querySelector('.add-to-cart-text')
           returned null and the button had 0 element children. */
        function labelNodeOf(btn) {
          var wrap = btn.querySelector('.add-to-cart-text');
          if (wrap) return wrap; // 4.1.1 shape, still handled
          for (var i = 0; i < btn.childNodes.length; i++) {
            var n = btn.childNodes[i];
            if (n.nodeType === 3 && n.nodeValue.trim()) return n;
          }
          // Nothing to write into yet. Insert before the burst so it stays last.
          var t = document.createTextNode('');
          btn.insertBefore(t, btn.querySelector('.add-to-cart__added') || null);
          return t;
        }

        function labelTextOf(node) {
          return (node.nodeType === 3 ? node.nodeValue : node.textContent).trim();
        }

        function setLabelText(node, value) {
          if (node.nodeType === 3) node.nodeValue = value;
          else node.textContent = value;
        }

        /* The button is the validator. No red strings anywhere in this block. */
        function syncMainButton() {
          var btn = mainButton();
          if (!btn) return;
          var label = labelNodeOf(btn);
          if (mainDefault === null) mainDefault = labelTextOf(label);

          var p = pack();
          var isCustom = (options()[choice] || {}).key === 'custom';
          var want;
          if (!selectedSize()) want = 'Select your size';
          /* No pack tile ticked yet.

             This has to be tested explicitly, and it has to come BEFORE any
             relational comparison against `size`. `size` is null until a tile
             is clicked (nothing is pre-selected, owner 2026-08-12), and the
             next branch down asks `p.length >= size`, which with an empty pack
             is `0 >= null`. A relational operator coerces null to ZERO, so
             that reads 0 >= 0 and evaluates TRUE. The button then built its
             label out of the null: "Add null-pack to cart · C$0", the moment a
             size was chosen (owner 2026-08-13).

             Only !, == and != see null as empty. <, >, <= and >= do not.

             Wording is the section heading verbatim on purpose here. The
             echo note on the branch below is about a DIFFERENT step -- that
             one asks which colours and should not borrow this label -- but at
             this point the pack really is the outstanding decision, and the
             heading is what the customer is being pointed at. */
          else if (!size) want = 'Choose your pack';
          /* Size 1 is exempt: it renders no colour cards, so there is nothing
             left to choose and this branch must not catch it.

             Was "Choose your pack", which is word-for-word the section heading
             above the SIZE tiles. Two different decisions wearing the same
             label: the heading asks how many, this button asks which colours.
             Naming the actual next action removes the echo and is more useful
             than the generic it replaced. */
          else if (size > 1 && choice < 0 && !single) want = 'Choose your colours';
          /* The same words submit() uses when it refuses a pack, written here so
             they stay on the button instead of flashing for one frame under the
             spinner (2026-10-18). */
          else if (p.length && !packBuyable(p)) {
            var outC = p.filter(function (n) { return !availableIn(n); })[0];
            want = outC + ' is sold out' + (selectedSize() ? ' in ' + selectedSize() : '');
          }
          else if (p.length >= size) {
            // "Add 1-pack" is not a thing anyone says.
            /* The button names what goes in the basket, not what it costs
               (owner 2026-08-26: "the add-to-cart should just say Add 3 pairs to
               cart"). Same reasoning as the rows above: the total belongs to the
               cart, where it is exact rather than rounded up for display. It
               also retires the last place where a rounded figure sat next to a
               different rounded figure and invited the customer to check the
               arithmetic. */
            want = size === 1 ? 'Add 1 pair to cart' : 'Add ' + size + ' pairs to cart';
          }
          /* An empty Build-your-own used to fall through to Horizon's own "Add to
             cart", which submit() then refused because the pack was short: a live
             looking button that did nothing. Say what is still needed instead. */
          else if (isCustom && !p.length) want = 'Choose ' + size + ' pairs';
          else if (p.length) want = 'Choose ' + (size - p.length) + ' more';
          else want = mainDefault;

          /* THE CAPSULE WEARS THE SAME WORDS (owner 2026-09-23: "it doesn't
             auto update... it's got to dynamically go through each step").
             The sticky's gated label was a fixed 'Choose your pack', so it
             asked for a pack that was already chosen while this button said
             "Choose 3 pairs". nether-pdp.css shows data-nether-step only while
             the pack is incomplete and the size is chosen, so the other labels
             written here are never seen. Horizon's own default is not copied: a
             gated capsule reading "Add to cart" would be a live-looking button
             that refuses, so that case keeps the CSS fallback. Written only on
             change, like the label below. */
          var sticky = document.querySelector('.sticky-add-to-cart__button');
          if (sticky) {
            if (want && want !== mainDefault) {
              if (sticky.getAttribute('data-nether-step') !== want) sticky.setAttribute('data-nether-step', want);
            } else if (sticky.hasAttribute('data-nether-step')) {
              sticky.removeAttribute('data-nether-step');
            }
          }

          // Write only on change: the observer below watches what this mutates.
          if (labelTextOf(label) !== want) setLabelText(label, want);
          syncCapsule(p);
        }

        /* THE CAPSULE NAMES THE PACK (owner 2026-10-22, from the AG1 round: "Just sticky bar names the
           pack that should be there"). With 3 pairs chosen the buy button said "Add 3 pairs to cart"
           while the capsule still read "Roam Boxer Brief / C$48 · Midnight", and its tap added three
           pairs. Once a pack of 2 or more is complete and buyable, the capsule reads the pack and its
           per-pair price, "3 × Midnight" over "C$44 each pair · M", the same figure as the ladder row.
           One pair, an unfinished pack or no size leaves the capsule exactly as Horizon draws it.

           Written on the <sticky-add-to-cart> HOST as data-nether-capsule plus CSS string properties (NOT
           data-nether-pack: that is this block's own hook and nether-pdp re-arms its add sequencer on any
           click inside it, which cancelled the capsule's confirmation; review 2026-10-22),
           shown by css-source/nether-pdp.css. Not inside the bar: sticky-add-to-cart.js morphs the bar's
           children on every variant change and would wipe it. Written only on change, so the host
           observer below cannot loop. */
        function syncCapsule(p) {
          var host = document.querySelector('sticky-add-to-cart');
          if (!host) return;
          /* Screen readers: the generated text is not read, and the capsule's own name and price are
             hidden in pack mode so they cannot contradict it, so the pack goes on the bar's region
             label. The bar element survives sticky-add-to-cart.js's children-only morph. */
          var bar = host.querySelector('.sticky-add-to-cart__bar');
          if (bar && !host.hasAttribute('data-nether-capsule-region')) host.setAttribute('data-nether-capsule-region', bar.getAttribute('aria-label') || '');
          var region = host.getAttribute('data-nether-capsule-region') || '';
          var sz = selectedSize();
          var on = !!sz && size > 1 && p && p.length >= size && packBuyable(p);
          if (!on) {
            if (host.hasAttribute('data-nether-capsule')) {
              host.removeAttribute('data-nether-capsule');
              host.style.removeProperty('--nether-pack-title');
              host.style.removeProperty('--nether-pack-sub');
              host.style.removeProperty('--nether-pack-sub-short');
            }
            if (bar && region && bar.getAttribute('aria-label') !== region) bar.setAttribute('aria-label', region);
            return;
          }
          var o = options()[choice] || {};
          var title;
          if (single || !o.key) title = size + ' pairs';
          else if (o.key === 'custom') {
            /* One colour reads like the solid card ("3 × Midnight", owner 2026-08-12: the multiplier
               keeps the count from reading as part of the name). A mix fits the capsule only when
               short; past 14 characters it says the count, and the ticked card still names the mix. */
            var one = custom.every(function (c) { return c === custom[0]; });
            title = one ? size + ' × ' + custom[0] : describe(custom);
            if (title.length > 14) title = size + ' pairs';
          } else title = o.name;
          var each = money(Math.ceil(totalFor(size) / size));
          var sub = each + ' each pair · ' + sz;
          var subShort = each + ' · ' + sz;
          var t = JSON.stringify(title), u = JSON.stringify(sub), v = JSON.stringify(subShort);
          if (host.getAttribute('data-nether-capsule') !== title) host.setAttribute('data-nether-capsule', title);
          if (host.style.getPropertyValue('--nether-pack-title') !== t) host.style.setProperty('--nether-pack-title', t);
          if (host.style.getPropertyValue('--nether-pack-sub') !== u) host.style.setProperty('--nether-pack-sub', u);
          if (host.style.getPropertyValue('--nether-pack-sub-short') !== v) host.style.setProperty('--nether-pack-sub-short', v);
          var spoken = (region ? region + ': ' : '') + title + ', ' + each + ' each pair, size ' + sz;
          if (bar && bar.getAttribute('aria-label') !== spoken) bar.setAttribute('aria-label', spoken);
        }

        if (addBtn) addBtn.addEventListener('click', function () {
          if (custom.length >= size) return;
          custom.push(armedColor());
          render();
        });

        function submit() {
          var p = pack();
          if (!p.length || p.length < size) { syncMainButton(); return; }
          var sz = selectedSize();
          if (!sz) { syncMainButton(); return; }

          var counts = {};
          p.forEach(function (n) { counts[n] = (counts[n] || 0) + 1; });
          var items = [], missingNames = [];
          Object.keys(counts).forEach(function (n) {
            var id = variantMap[n + '::' + sz];
            if (!id) { missingNames.push(n); return; }
            items.push({ id: id, quantity: counts[n] });
          });
          if (missingNames.length || !items.length) {
            /* Name the colour, not the size.

               This said "That size is sold out", which is usually false: the
               size is fine, one colourway in it is not, and the customer is
               left re-picking a size that was never the problem. availableIn()
               now stops most of these at the stepper, so reaching here means
               either a solid or One of Each card, or stock that ran out while
               the page sat open. Either way the useful sentence names what to
               change.

               Written through setLabelText/labelNodeOf like every other label
               in this block. Writing .add-to-cart-text directly is what left a
               second label behind on 4.1.4, where that element moved. */
            var b0 = mainButton();
            if (b0) {
              setLabelText(
                labelNodeOf(b0),
                missingNames.length === 1
                  ? missingNames[0] + ' is sold out in ' + sz
                  : 'Sold out in ' + sz + ': ' + missingNames.join(', ')
              );
            }
            return;
          }

          var routes = (window.Theme && window.Theme.routes) || {};
          var addUrl = routes.cart_add_url || '/cart/add.js';
          var cartUrl = routes.cart_url || '/cart';
          var sectionIds = [];
          document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) {
            sectionIds.push(c.dataset.sectionId);
          });
          var body = { items: items };
          if (sectionIds.length) body.sections = sectionIds.join(',');

          fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          })
            .then(function (r) { return r.json(); })
            .then(function (addResp) {
              if (addResp.status) throw new Error('add failed');
              return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  var refreshed = window.NetherCart && window.NetherCart.refreshCartSections
                    ? window.NetherCart.refreshCartSections(addResp.sections)
                    : Promise.resolve(false);
                  return Promise.resolve(refreshed).then(function () { return cart; });
                })
                .then(function (cart) {
                  var ev = new Event('shopify:cart:lines-update', { bubbles: true });
                  ev.action = 'add';
                  ev.context = 'product';
                  ev.lines = items.map(function (it) {
                    return { merchandiseId: String(it.id), quantity: it.quantity };
                  });
                  ev.promise = Promise.resolve({
                    cart: null,
                    detail: {
                      itemCount: cart.item_count,
                      items: cart.items,
                      sections: addResp.sections,
                      source: 'nether-pack-builder',
                      didError: false
                    }
                  });
                  document.dispatchEvent(ev);
                  custom = [];
                  render();
                });
            })
            .catch(function () {
              var b1 = mainButton();
              if (b1) (b1.querySelector('.add-to-cart-text') || b1).textContent = 'Try that again';
            });
        }

        /* WINDOW capture, not document, and the sticky bar's own button is in the
           selector. Both matter, and the mobile buy path was dead without them.

           Measured 2026-08-10 at 375px: sticky bar visible, tapped, cart 0 -> 0.
           The chain is that nether-pdp.liquid's ATC sequencer registers a
           document-capture listener from an INLINE script, so it always beats a
           block's. A sticky tap sets data-nether-atc, then sticky-add-to-cart.js
           fires a synthetic click on the real button, which re-enters that guard
           and hits stopImmediatePropagation (nether-pdp.liquid:2670) — killing
           this listener before it runs. Window capture fires ahead of every
           document listener whatever the load order, so this now sees the tap
           first either way.

           preventDefault only, never stopImmediatePropagation: the sequencer
           still gets the event and still plays its pending-to-resolved
           animation. It just no longer decides whether anything is added. */
        var lastSubmitAt = 0;
        window.addEventListener('click', function (e) {
          var t = e.target;
          if (!t || !t.closest) return;
          /* The capsule's BUTTON, not the whole capsule (review, 2026-10-22). Matching the host let a tap on
             its picture or text submit a pack, which Horizon never treats as an add. */
          if (!t.closest('.buy-buttons-block, product-form-component, .sticky-add-to-cart__button')) return;
          /* Only ever speak for a page this block is actually on. */
          if (!pb || !document.contains(pb)) return;
          /* An add is already under way or just landed ("In your cart, 3 pairs"). nether-pdp's sequencer
             swallows that press on document capture, but this window listener runs first and used to
             submit another pack before it could (review, 2026-10-22). Hand the press to the sequencer. */
          if (document.documentElement.hasAttribute('data-nether-atc')) return;

          /* The pack is a GATE, not a hint.

             This used to open with `if (!pack().length) return;` above the
             target test, and that one line let the whole thing through. It was
             written when a pack was always pre-selected, so an empty pack could
             only mean "not a pack product, let Horizon have the click". Since
             nothing is pre-selected (2026-08-12) an empty pack is the ordinary
             opening state, so the interceptor stood down on exactly the press it
             existed to catch: Horizon's own add-to-cart ran and put one pair in
             the bag while the button still read "Choose your pack" (owner
             2026-08-13: "it just adds one right to the cart").

             So an incomplete pack now preventDefaults like a complete one. The
             difference is only whether submit() is reached. Bailing early is
             never the safe default in a capture-phase guard — it hands the
             event to whoever is behind you. */
          var p = pack();
          if (!size || !p.length || p.length < size || !packBuyable(p)) {
            e.preventDefault();

            /* preventDefault is not enough to stop the success burst.

               There are TWO burst mechanisms and they are easy to confuse. Ours
               rides html[data-nether-atc] and is driven by nether-pdp.liquid's
               sequencer, which the mix-incomplete flag already silences.
               Horizon's own add-to-cart-component separately sets
               data-added="true" ON THE BUTTON, and our CSS runs nether-atc-pop
               off that attribute. preventDefault only cancels the form submit,
               which is the click's default action; it does nothing to Horizon's
               listener, so the component still marked the press as an add and
               the checkmark played over a refusal, then stayed stuck true.

               Measured: data-nether-atc stayed null the whole time while
               data-added flipped to true. A check that watches only our own
               flag will call this fixed when it is not.

               stopImmediatePropagation is gated on a size being chosen, and
               that condition is the important part. This branch also catches
               "no size at all", and on that path Horizon's .button is
               pointer-events:none so the press lands on the component wrapper
               instead, no data-added is set, and the only listener that wants
               the event is nether-pdp's size-error handler -- which is
               bubble-phase, so stopping here would kill the red size box. Stop
               the event only when the pack is genuinely the one thing missing. */
            if (selectedSize()) e.stopImmediatePropagation();

            /* Clear it regardless. Cheap, and it un-sticks the state if
               anything else optimistically marked the button before us. */
            document.querySelectorAll(
              '.product-details [data-added], .sticky-add-to-cart__button[data-added]'
            ).forEach(function (b) { b.removeAttribute('data-added'); });

            /* THE FLAG AND THE SCROLL ARE GATED THE SAME WAY THE EVENT IS.

               The comment above already reasons that this branch also catches
               "no size at all", and stops the event only when the pack is
               genuinely the one thing missing — then set the error and scrolled
               unconditionally anyway. So pressing Add with NOTHING chosen lit
               the pack row red while nether-pdp's size gate was lighting the
               size row red, and the two scrolls fought: the size gate sent the
               page up to the sizes, this one sent it down to the packs.

               Owner 2026-09-05: "it brings you back up, and then I selected the
               size and then the error state for the selected pack just broken.
               It just automatically did it without even selecting a pack."

               With no size, the first missing thing is the size and the size
               gate owns the message. Only claim the pack is missing when it is
               the ONLY thing missing. */
            if (selectedSize() && !size) {
              document.documentElement.setAttribute('data-nether-pack-error', '');

              /* Say where to look, the same way the size gate does. */
              if (segEl) segEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else if (selectedSize()) {
              /* THE PACK SIZE IS ANSWERED; THE COLOURS ARE NOT (owner
                 2026-09-23: "it scrolled me back up with the red error message
                 instead of... select the bundle").

                 This branch used to light the pack-size row red under "Choose
                 a pack size." whenever the pack was short. That included 3
                 pairs plainly chosen with only Build Your Own's colours
                 missing, so a sticky tap parked the customer on the one row
                 already answered, with the colour picker below the fold. The
                 same mistake the render() note above fixed on 08-23, reached by
                 a different road.

                 Walk to the step that is actually open, with no red: the option
                 cards when none is chosen, the colour picker when Build Your
                 Own is short. The buy button there already says how many are
                 left.

                 scrollIntoView, like the branch above, not follow(): follow()
                 moves the window, and on desktop the page scrolls inside
                 .page-wrapper, so it would leave a desktop tap going nowhere.
                 A step already on screen stays put, which it is for a tap on
                 the buy button itself. */
              var customNow = (options()[choice] || {}).key === 'custom';
              var stepEl = choice < 0 || !customNow ? optsEl : buildEl;
              if (stepEl) {
                var sr = stepEl.getBoundingClientRect();
                /* In the buy sheet (nether-buy-sheet.js) "on screen" means
                   inside the sheet's scrolling box and above its pinned buy
                   button, not inside the window: a step scrolled up under
                   the sheet's head is still inside the window, and was
                   being left there (2026-09-25). */
                var box = stepEl.closest('.nether-buy-sheet__body');
                var seeTop = 0;
                var seeBottom = window.innerHeight;
                if (box) {
                  var br = box.getBoundingClientRect();
                  var pin = box.querySelector('.buy-buttons-block');
                  seeTop = br.top;
                  seeBottom = pin ? Math.min(br.bottom, pin.getBoundingClientRect().top) : br.bottom;
                }
                if (sr.top < seeTop || sr.bottom > seeBottom) {
                  var still = window.matchMedia &&
                    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                  stepEl.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'center' });
                }
              }
            }

            syncMainButton();
            return;
          }

          e.preventDefault();
          document.documentElement.removeAttribute('data-nether-pack-error');

          /* One tap, one add. The sticky path produces TWO events — the real tap
             and the synthetic click it fires at the main button — and both reach
             here now. Anything inside the window is the same press. */
          var now = new Date().getTime();
          if (now - lastSubmitAt < 1500) return;
          lastSubmitAt = now;
          submit();
        }, true);

        /* Choosing a colourway upstairs renames and recolours the generated
           packs, so this rerenders rather than only resyncing the button. */
        document.addEventListener('variant:selected', function () { armed = null; render(); });

        /* ...and the event alone is not enough. Measured: clicked Storm, waited
           1.8s, and the swatch row correctly read Storm while the packs still
           said "Midnight three" with #1A1A1A strips. The DOM was right and the
           block simply never re-ran. Watching is-selected on the swatch row does
           not care which event the colourway block fires, or whether it fires
           one at all. Safe from loops: this rerenders .nether-pb, not the row
           being observed. */
        var cw = document.querySelector('.nether-colorway');
        if (cw) {
          var t1 = 0;
          new MutationObserver(function () {
            clearTimeout(t1);
            t1 = setTimeout(function () { armed = null; render(); }, 40);
          }).observe(cw, { attributes: true, attributeFilter: ['class'], subtree: true });
        }

        /* The size gate in nether-pdp.liquid clears Horizon's pre-selected size
           AFTER this block initialises, and clearing is programmatic so it fires
           no change event. Measured: every radio unchecked while the button
           still read "Add 3-pack to cart · C$122.55". */
        /* Choosing a size both REVEALS this block (the collapse lives in
           snippets/nether-pdp.liquid) and makes it the next thing to do, so the
           view is walked to it — the same courtesy the pack and colour steps get.

           Edge-triggered, not level: this fires only on the needs-size ->
           has-size transition. Firing on every mutation would scroll the page
           when the attribute is re-set for any other reason, and firing on load
           would yank a customer who has not touched anything.

           400ms because the reveal is a --motion-panel collapse. follow()
           measures the target to decide whether it even needs to move, and at
           60ms it would be measuring a box still growing from zero height. */
        var neededSize = document.documentElement.hasAttribute('data-nether-needs-size');
        new MutationObserver(function () {
          syncMainButton();
          var needs = document.documentElement.hasAttribute('data-nether-needs-size');
          if (neededSize && !needs) follow(segEl, 420);
          neededSize = needs;
        }).observe(document.documentElement, {
          attributes: true,
          attributeFilter: ['data-nether-needs-size']
        });

        /* If anything rewrites the capsule host (a section morph), put the pack back. syncCapsule
           writes only on change, so this settles after one pass. */
        var capHost = document.querySelector('sticky-add-to-cart');
        if (capHost) {
          new MutationObserver(function () { syncCapsule(pack()); })
            .observe(capHost, { attributes: true, attributeFilter: ['data-nether-capsule', 'style'] });
        }

        /* Picking a size morphs the section and swaps in a fresh add-to-cart
           button carrying Horizon's own label, after variant:selected has fired. */
        var details = document.querySelector('.product-details');
        if (details) {
          var t0 = 0;
          new MutationObserver(function () {
            clearTimeout(t0);
            t0 = setTimeout(syncMainButton, 60);
          }).observe(details, { childList: true, subtree: true });
        }

        render();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nether-size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    // Sizing model. Waist correlates with height + weight; build nudges it.
    // The size ranges are parsed from the rendered size chart table so the
    // calculator can never disagree with the chart the customer is reading —
    // edit the waist settings and the math follows. FALLBACK matches the
    // schema defaults in case parsing ever fails.
    /* Only used if the rendered table cannot be read. It must still MATCH the
       table, or a parse failure would quietly hand out different sizes than the
       chart on screen. Updated with the 2026-08-03 ladder: even 3-inch bands,
       contiguous, replacing the old 2/2/2/4/4 spread whose wide XL and XXL were
       the two least certain sizes to buy. */
    var FALLBACK_CHART = [
      { size: 'S', min: 29, max: 32 },
      { size: 'M', min: 32, max: 35 },
      { size: 'L', min: 35, max: 38 },
      { size: 'XL', min: 38, max: 41 },
      { size: 'XXL', min: 41, max: 44 }
    ];
    function chartFromTable(drawer) {
      var rows = drawer.querySelectorAll('.nether-sg__table tbody tr[data-sg-size]');
      var chart = [];
      rows.forEach(function (tr) {
        var size = tr.getAttribute('data-sg-size');
        var waistText = tr.cells && tr.cells[1] ? tr.cells[1].textContent : '';
        var m = waistText.match(/(\d+(?:\.\d+)?)\s*[-–]\s*(\d+(?:\.\d+)?)/);
        if (size && m) chart.push({ size: size, min: parseFloat(m[1]), max: parseFloat(m[2]), label: waistText.trim() });
      });
      return chart.length >= 2 ? chart : FALLBACK_CHART;
    }
    var SIZE_VALUE_MAP = {
      S: ['s', 'sm', 's/m', 'small'],
      M: ['m', 'medium'],
      L: ['l', 'large'],
      XL: ['xl', 'x-large', 'xlarge', 'extralarge'],
      XXL: ['xxl', '2xl', 'xx-large', 'xxlarge']
    };
    function normVal(v) { return String(v || '').trim().toLowerCase().replace(/\s+/g, '').replace(/[_]+/g, ''); }
    function estWaistIn(hIn, wLb, build) {
      var w = (0.082 * wLb) + (0.18 * hIn) + 6.5;
      if (build === 'athletic') w += 1.0; else if (build === 'slim') w -= 0.75;
      return Math.min(50, Math.max(26, w));
    }
    function pickFromChart(chart, w) {
      if (w <= chart[0].min) return chart[0];
      if (w >= chart[chart.length - 1].max) return chart[chart.length - 1];
      for (var i = 0; i < chart.length; i++) { if (w >= chart[i].min && w < chart[i].max) return chart[i]; }
      // Between rows (non-contiguous ranges): take the first size whose max
      // covers the estimate — sizing up, matching the fit notes.
      for (var j = 0; j < chart.length; j++) { if (w < chart[j].max) return chart[j]; }
      return chart[Math.floor(chart.length / 2)];
    }
    function selectSize(details, size) {
      var cands = SIZE_VALUE_MAP[size] || [normVal(size)];
      var inputs = details.querySelectorAll('.variant-option input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) {
        if (cands.indexOf(normVal(inputs[i].value)) === -1) continue;
        if (inputs[i].disabled || inputs[i].getAttribute('aria-disabled') === 'true' || inputs[i].getAttribute('data-option-available') === 'false') {
          return { ok: false, soldout: true };
        }
        inputs[i].checked = true;
        inputs[i].dispatchEvent(new Event('input', { bubbles: true }));
        inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
        inputs[i].click();
        return { ok: true };
      }
      return { ok: false };
    }

    // Sold-out advice names a size that exists and is in stock (bug hunt 2026-10-22). It always said
    // "Try the next size up", including for XXL, and for XL when XXL was sold out too (Boxer Brief I).
    var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
    function inStock(details, size) {
      var cands = SIZE_VALUE_MAP[size] || [normVal(size)];
      var inputs = details.querySelectorAll('.variant-option input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) {
        if (cands.indexOf(normVal(inputs[i].value)) === -1) continue;
        return !(inputs[i].disabled || inputs[i].getAttribute('aria-disabled') === 'true' || inputs[i].getAttribute('data-option-available') === 'false');
      }
      return false;
    }
    function soldOutLine(details, size) {
      var k = SIZE_ORDER.indexOf(String(size).toUpperCase());
      for (var n = k + 1; k !== -1 && n < SIZE_ORDER.length; n++) {
        if (inStock(details, SIZE_ORDER[n])) return size + ' is sold out. Try ' + SIZE_ORDER[n] + '.';
      }
      return size + ' is sold out right now.';
    }

    function init(root) {
      var wraps = (root || document).querySelectorAll('[data-nether-sg]:not([data-sg-init])');
      wraps.forEach(function (wrap) {
        wrap.setAttribute('data-sg-init', 'true');
        var openBtn = wrap.querySelector('[data-sg-open]');
        var drawer = wrap.querySelector('[data-sg-root]');
        if (!openBtn || !drawer) return;
        var panel = drawer.querySelector('.nether-sg__panel');
        var details = wrap.closest('.product-details') || document;

        // Move the drawer to <body> so it escapes any stacking/clip context.
        // Carry the page's colour-scheme class onto the PANEL (not the root) so
        // its tokens + the dark-mode bridge resolve, without the full-viewport
        // root painting a solid background over the page.
        if (drawer.parentElement !== document.body) {
          var schemeHost = wrap.closest('[class*="color-scheme-"]');
          if (schemeHost) {
            var m = schemeHost.className.match(/color-scheme-[^\s]+/);
            if (m) (drawer.querySelector('.nether-sg__panel') || drawer).classList.add(m[0]);
          }
          document.body.appendChild(drawer);
        }

        // The trigger stays in this block's own container (rendered right after the
        // size picker) so Horizon's variant-picker re-render can never wipe it.

        var prevFocus = null;
        function open() {
          drawer.classList.add('is-open');
          drawer.setAttribute('aria-hidden', 'false');
          document.body.classList.add('nether-sg-lock');
          // body overflow is a no-op at >=990px (.page-wrapper is the
          // scroller) — Horizon's scroll-lock attribute locks both.
          document.documentElement.setAttribute('scroll-lock', '');
          document.addEventListener('keydown', onKey);
          prevFocus = document.activeElement;
          var c = drawer.querySelector('.nether-sg__close');
          if (c) c.focus();
        }
        function close() {
          // Restore focus FIRST: aria-hidden on an ancestor of the focused
          // close button gets blocked by the browser otherwise.
          if (prevFocus && typeof prevFocus.focus === 'function') prevFocus.focus();
          drawer.classList.remove('is-open');
          drawer.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('nether-sg-lock');
          document.documentElement.removeAttribute('scroll-lock');
          document.removeEventListener('keydown', onKey);
        }
        /* Escape and focus restore were already handled. Tab was not, so focus
           walked straight out of the open drawer and into the page behind it,
           leaving a keyboard user tabbing through content they cannot see. A
           modal has to hold focus for as long as it is modal. */
        function focusables() {
          return Array.prototype.filter.call(
            drawer.querySelectorAll(
              'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
            ),
            function (el) { return el.offsetParent !== null || el === document.activeElement; }
          );
        }
        function onKey(e) {
          if (e.key === 'Escape') { close(); return; }
          if (e.key !== 'Tab') return;
          var f = focusables();
          if (!f.length) return;
          var first = f[0];
          var last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }

        openBtn.addEventListener('click', open);
        drawer.querySelectorAll('[data-sg-close]').forEach(function (b) { b.addEventListener('click', close); });

        // Tappable chart rows select the size + close.
        drawer.querySelectorAll('[data-sg-size]').forEach(function (rowEl) {
          function pick() {
            var val = rowEl.getAttribute('data-sg-size');
            var input = details.querySelector('.variant-option input[type="radio"][value="' + (window.CSS && CSS.escape ? CSS.escape(val) : val) + '"]');
            if (input && !input.disabled) {
              input.checked = true;
              input.dispatchEvent(new Event('input', { bubbles: true }));
              input.dispatchEvent(new Event('change', { bubbles: true }));
              input.click();
              close();
            }
          }
          rowEl.addEventListener('click', pick);
          rowEl.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
        });

        // Swipe-down dismiss on mobile.
        var startY = 0;
        panel.addEventListener('touchstart', function (e) { startY = e.touches[0].clientY; }, { passive: true });
        panel.addEventListener('touchmove', function (e) { if (e.touches[0].clientY - startY > 90) close(); }, { passive: true });

        // ---- Calculator ---- (drawer is moved to <body>, so scope to it, not wrap)
        var calc = drawer.querySelector('[data-sg-calc]');
        if (calc) {
          var unit = 'imperial', build = 'average', lastSize = null;
          var errEl = calc.querySelector('[data-sg-error]');
          var resultEl = calc.querySelector('[data-sg-result]');

          function setActive(group, btn) {
            calc.querySelectorAll(group).forEach(function (x) { x.classList.remove('is-active'); });
            btn.classList.add('is-active');
          }
          function num(sel) {
            var el = calc.querySelector(sel); if (!el) return null;
            var v = (el.value || '').trim(); if (v === '') return null;
            var n = Number(v); return isFinite(n) ? n : null;
          }
          function showErr(m) { if (errEl) { errEl.textContent = m; errEl.hidden = false; } }
          function clearErr() { if (errEl) { errEl.textContent = ''; errEl.hidden = true; } }

          calc.querySelectorAll('[data-sg-mode]').forEach(function (b) {
            b.addEventListener('click', function () {
              setActive('[data-sg-mode]', b);
              var m = b.getAttribute('data-sg-mode');
              calc.querySelector('[data-sg-pane="self"]').hidden = (m !== 'self');
              calc.querySelector('[data-sg-pane="gift"]').hidden = (m !== 'gift');
            });
          });
          // --- Sliders (height + weight), unit-aware with a filled track ---
          var heightEl = calc.querySelector('[data-sg-height]');
          var weightEl = calc.querySelector('[data-sg-weight]');
          var heightDisp = calc.querySelector('[data-sg-height-display]');
          var weightDisp = calc.querySelector('[data-sg-weight-display]');
          var RANGES = {
            imperial: { h: { min: 58, max: 84 }, w: { min: 90, max: 350 } },
            metric: { h: { min: 147, max: 213 }, w: { min: 40, max: 160 } }
          };
          function fill(el) {
            var min = +el.min, max = +el.max, v = +el.value;
            el.style.setProperty('--pct', (max > min ? ((v - min) / (max - min)) * 100 : 0) + '%');
          }
          function renderDisplays() {
            if (unit === 'imperial') {
              var inch = +heightEl.value;
              heightDisp.textContent = Math.floor(inch / 12) + "' " + (inch % 12) + '"';
              weightDisp.textContent = (+weightEl.value) + ' lb';
            } else {
              heightDisp.textContent = (+heightEl.value) + ' cm';
              weightDisp.textContent = (+weightEl.value) + ' kg';
            }
            fill(heightEl); fill(weightEl);
          }
          function applyUnit(toUnit) {
            var curImp = unit === 'imperial';
            var hIn = curImp ? +heightEl.value : (+heightEl.value) / 2.54;
            var wLb = curImp ? +weightEl.value : (+weightEl.value) * 2.2046226218;
            unit = toUnit;
            var r = RANGES[unit];
            heightEl.min = r.h.min; heightEl.max = r.h.max;
            weightEl.min = r.w.min; weightEl.max = r.w.max;
            var nh = unit === 'imperial' ? hIn : hIn * 2.54;
            var nw = unit === 'imperial' ? wLb : wLb / 2.2046226218;
            heightEl.value = Math.round(Math.min(r.h.max, Math.max(r.h.min, nh)));
            weightEl.value = Math.round(Math.min(r.w.max, Math.max(r.w.min, nw)));
            renderDisplays();
          }

          calc.querySelectorAll('[data-sg-unit]').forEach(function (b) {
            b.addEventListener('click', function () {
              if (b.getAttribute('data-sg-unit') === unit) return;
              setActive('[data-sg-unit]', b);
              applyUnit(b.getAttribute('data-sg-unit'));
            });
          });
          if (heightEl) heightEl.addEventListener('input', renderDisplays);
          if (weightEl) weightEl.addEventListener('input', renderDisplays);
          renderDisplays();

          var goBtn = calc.querySelector('[data-sg-go]');
          if (goBtn) goBtn.addEventListener('click', function () {
            clearErr();
            var hIn, wLb;
            if (unit === 'imperial') { hIn = +heightEl.value; wLb = +weightEl.value; }
            else { hIn = (+heightEl.value) / 2.54; wLb = (+weightEl.value) * 2.2046226218; }
            var row = pickFromChart(chartFromTable(drawer), estWaistIn(hIn, wLb, build));
            lastSize = row.size;
            resultEl.querySelector('[data-sg-result-size]').textContent = row.size;
            resultEl.querySelector('[data-sg-result-waist]').textContent = row.label ? row.label + ' waist' : '';
            resultEl.querySelector('[data-sg-select-size]').textContent = row.size;
            resultEl.hidden = false;
          });

          /* "Try the next size up" is no help when the COLOUR is out in every size
             (Abyss, 2026-10-18): nether-pdp flags that page state on <html>. Then
             the advice is to pick another colour, which is the only way forward. */
          function soldOutMsg(fallback) {
            if (!document.documentElement.hasAttribute('data-nether-all-out')) return fallback;
            var nameEl = document.querySelector('.product-details [data-colorway-name]');
            var colour = nameEl ? nameEl.textContent.trim() : '';
            return colour ? colour + ' is sold out in every size. Pick another colour above.' : fallback;
          }

          var selBtn = calc.querySelector('[data-sg-select]');
          if (selBtn) selBtn.addEventListener('click', function () {
            if (!lastSize) return;
            var r = selectSize(details, lastSize);
            if (r.ok) close(); else if (r.soldout) showErr(soldOutMsg(soldOutLine(details, lastSize)));
            else showErr('That size is not available.');
          });

          // ---- Gift flow: know his pant size? yes -> waist pills -> estimate;
          //      no -> M (fits most) or hop to the height/weight sliders. ----
          var giftYes = calc.querySelector('[data-sg-gift-yes]');
          var giftNo = calc.querySelector('[data-sg-gift-no]');
          var giftResult = calc.querySelector('[data-sg-gift-result]');
          var giftErr = calc.querySelector('[data-sg-gift-error]');
          var giftSize = null;
          function giftShowErr(m) { if (giftErr) { giftErr.textContent = m; giftErr.hidden = false; } }
          function giftClearErr() { if (giftErr) { giftErr.textContent = ''; giftErr.hidden = true; } }

          calc.querySelectorAll('[data-sg-gift-yn]').forEach(function (b) {
            b.addEventListener('click', function () {
              setActive('[data-sg-gift-yn]', b);
              var yes = b.getAttribute('data-sg-gift-yn') === 'yes';
              if (giftYes) giftYes.hidden = !yes;
              if (giftNo) giftNo.hidden = yes;
              giftClearErr();
            });
          });

          calc.querySelectorAll('[data-sg-waist]').forEach(function (b) {
            b.addEventListener('click', function () {
              setActive('[data-sg-waist]', b);
              giftClearErr();
              // A pant waist at a row boundary (e.g. 32 vs the 30-32 / 32-34 split)
              // lands on the LARGER size — pants understate real waist, and the
              // fit guidance is size up anyway.
              var w = parseFloat(b.getAttribute('data-sg-waist'));
              var row = pickFromChart(chartFromTable(drawer), w);
              giftSize = row.size;
              giftResult.querySelector('[data-sg-gift-result-size]').textContent = row.size;
              giftResult.querySelector('[data-sg-gift-result-waist]').textContent = row.label ? row.label + ' waist' : '';
              giftResult.querySelector('[data-sg-gift-select-size]').textContent = row.size;
              giftResult.hidden = false;
            });
          });

          var giftSel = calc.querySelector('[data-sg-gift-select]');
          if (giftSel) giftSel.addEventListener('click', function () {
            if (!giftSize) return;
            var r = selectSize(details, giftSize);
            if (r.ok) close(); else if (r.soldout) giftShowErr(soldOutMsg(soldOutLine(details, giftSize)));
            else giftShowErr('That size is not available.');
          });

          var giftM = calc.querySelector('[data-sg-gift-pick-m]');
          if (giftM) giftM.addEventListener('click', function () {
            var r = selectSize(details, 'L');
            if (r.ok) close(); else if (r.soldout) giftShowErr(soldOutMsg(soldOutLine(details, 'L')));
            else giftShowErr('That size is not available.');
          });

          var giftEst = calc.querySelector('[data-sg-gift-est]');
          if (giftEst) giftEst.addEventListener('click', function () {
            var selfBtn = calc.querySelector('[data-sg-mode="self"]');
            if (selfBtn) selfBtn.click();
          });
        }
      });
    }
    document.addEventListener('DOMContentLoaded', function () { init(document); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });

    // A variant morph re-renders .product-details from server HTML: it strips
    // the JS-set data-sg-init and inserts a FRESH wrap while the old drawer
    // stays orphaned on <body> — leaving "Find your size" dead after any
    // variant change. Re-init after the morph settles, clearing stale roots.
    function reinitAfterMorph() {
      setTimeout(function () {
        if (document.querySelector('[data-nether-sg]:not([data-sg-init])')) {
          document.querySelectorAll('body > .nether-sg__root:not(.is-open)').forEach(function (n) { n.remove(); });
          init(document);
        }
      }, 60);
    }
    ['variant:selected', 'variant:update'].forEach(function (ev) {
      document.addEventListener(ev, reinitAfterMorph, true);
    });
    document.addEventListener('shopify:product:select', function (e) {
      if (e && e.promise && typeof e.promise.then === 'function') {
        e.promise.then(reinitAfterMorph, reinitAfterMorph);
      } else {
        reinitAfterMorph();
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
